import React, { useContext, useEffect, useState } from "react";
import {
  getCategorys,
  getCompanys,
  getDepartments,
  getDesignation,
  GetDynamicOptions,
  getEmployee,
  getEsiData,
  getGroup,
  getMonthlyDetailedEmployeepayroll,
  GetNextVoucherNumber,
  GetPayrollColumnsforReport,
  getPayrollDetails,
  GetPayrolldetailsforreport,
  getPfData,
  getProfitCenter,
  insertEmpPayrollData,
  UpdateVoucherNumber,
} from "../../services/dataService";
import Breadcrumb from "../../components/common/Breadcrumb";
import auth_bg from "../../assets/images/attukal_bg.jpg";
import toast from "react-hot-toast";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Columnselecter from "../../components/Columnselecter";
import { AppProvider, useAppContext } from "../../Context/context";
import ColumnSelector from "../../components/Columnselecter";
import { getSecureItem, setSecureItem } from "../../services/SecureStorage";

function PayRollReport() {
  const UserName = getSecureItem("UserName");
  const UID = getSecureItem("userId");
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [filterMethod, setFilterMethod] = useState("");
  const [datafilter, setDataFilter] = useState([]);
  const [salaryOptions, setSalaryOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState("Daily");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [PayrollData, setPayrollData] = useState([]);
  const [DetailedMonthlyPayroll, setDetailedMonthlyPayroll] = useState([]);
  const [DetailedAddDedd, setDetailedAddDedd] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [additionsDeductions, setAdditionsDeductions] = useState([]);
  const [isAdditionsModalOpen, setAdditionsModalOpen] = useState(false);
  const [isDeductionsModalOpen, setDeductionsModalOpen] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState(""); // To store the selected filter
  const [filteredData, setFilteredData] = useState([]);
  const [category, setCategory] = useState([]);
  const [designation, setdesignation] = useState([]);
  const [showMonthly, setShowMonthly] = useState(false);
  const [group, setGroup] = useState([]);
  const [Department, setDepartment] = useState([]);
  const [FilterProfitcenter, setFilterProfitcenter] = useState([]);
  const [fromMonth, setFromMonth] = useState("");
  const [toMonth, setToMonth] = useState("");
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [employeeId, setEmployeeId] = useState("");
  const [filterdoption, setfilterdoption] = useState([]);
  const [pfData, setPfData] = useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [Esidata, setEsiData] = useState([]);

  const {
    selectedColumns,
    setSelectedColumns,
    selectedColumnsData,
    setSelectedColumnsData,
    reportSelect,
    setReportSelect,
    setSelectedColumns: setContextSelectedColumns,
    setSelectedColumnsData: setContextSelectedColumnsData,
  } = useAppContext();
  console.log(selectedColumnsData, "selectedColumnsData");
  const selectedPayrollColumns = JSON.parse(
    getSecureItem("selectedPayrollColumns") || "[]",
  );
  const fetchCompanyDetails = async () => {
    try {
      const response = await getCompanys(UID);
      setCompanyDetails(response.data.data[0]);
    } catch (error) {
      console.error("An error occurred:", error);
      toast.error("An error occurred while fetching company details");
    }
  };

  const fetchOptions = async () => {
    try {
      const response = await GetDynamicOptions({
        optionType: "SalaryGenerationOption",
      });
      setSalaryOptions(response.data.data);
    } catch (error) {
      console.error("Error fetching salary options:", error);
    }
  };

  const fetchcategory = async () => {
    try {
      const response = await getCategorys(UID);
      setCategory(response);
      // (category, "Filtered Pages");
    } catch (error) {
      //console.error("Error fetching cate:", error);
    }
  };
  const [columnsData, setColumnsData] = useState([]);

  const fetchparollReportColumns = async () => {
    try {
      const payload = {
        option: selectedOption,
        fromDate,
        toDate,
        UserId: UID,
      };

      const response = await GetPayrollColumnsforReport(payload);
      const employees = response?.data?.data?.[0] || [];

      // Parse Additions & Deductions
      const parsedEmployees = employees.map((emp) => ({
        ...emp,
        Additions: emp.Additions ? JSON.parse(emp.Additions) : [],
        Deductions: emp.Deductions ? JSON.parse(emp.Deductions) : [],
      }));

      setColumnsData(parsedEmployees);

      console.log(parsedEmployees, "Parsed Payroll Employees");

      // Access context setters (make sure useAppContext is available in this component)

      // Check if user has previously saved selection
      const saved = getSecureItem("selectedPayrollColumns");

      if (!saved && parsedEmployees.length > 0) {
        // Step 1: Extract ALL unique column headers
        const allHeadersSet = new Set();
        parsedEmployees.forEach((employee) => {
          [
            ...(employee.Additions || []),
            ...(employee.Deductions || []),
          ].forEach((item) => {
            const header = item.ColumnHeaderName?.trim();
            if (header) allHeadersSet.add(header);
          });
        });

        if (allHeadersSet.size > 0) {
          const selectedHeadersArray = Array.from(allHeadersSet);

          // Step 2: Reuse exact same transform logic as ColumnSelector
          const transformPayrollForSelectedColumns = (
            originalData,
            selectedHeadersSet,
          ) => {
            return originalData.map((employee) => {
              const result = { ...employee };
              const additions = [];
              const deductions = [];

              (employee.Additions || []).forEach((item) => {
                if (selectedHeadersSet.has(item.ColumnHeaderName?.trim())) {
                  additions.push(item);
                }
              });

              (employee.Deductions || []).forEach((item) => {
                if (selectedHeadersSet.has(item.ColumnHeaderName?.trim())) {
                  if (item.ComponentType === "Addition") {
                    additions.push(item);
                  } else {
                    deductions.push(item);
                  }
                }
              });

              result.Additions = additions;
              result.Deductions = deductions;
              return result;
            });
          };

          const transformedPayrollData = transformPayrollForSelectedColumns(
            parsedEmployees,
            allHeadersSet,
          );

          // Step 3: Save to localStorage (so ColumnSelector loads it correctly)
          setSecureItem(
            "selectedPayrollColumns",
            JSON.stringify(selectedHeadersArray),
          );

          // Step 4: Update Context IMMEDIATELY with full structure
          setContextSelectedColumns(allHeadersSet);
          setContextSelectedColumnsData({
            selectedHeaders: selectedHeadersArray,
            transformedPayrollData: transformedPayrollData,
          });

          console.log("First load: Auto-selected ALL columns");
          console.log("Selected Headers:", selectedHeadersArray);
          console.log(
            "Transformed Payroll Data saved to context:",
            transformedPayrollData,
          );
        }
      }
      // If saved selection exists → ColumnSelector's useEffect + onSave will handle context update
    } catch (error) {
      console.error("Error fetching payroll columns", error);
    }
  };

  const fetchdesignation = async () => {
    try {
      const response = await getDesignation(UID);
      setdesignation(response);
      //(designation, "Filtered Pages");
    } catch (error) {
      console.error("Error fetching cate:", error);
    }
  };

  const fetchGroup = async () => {
    try {
      const response = await getGroup(UID);

      setGroup(response);
      //(group, "Filtered Pages");
    } catch (error) {
      console.error("Error fetching cate:", error);
    }
  };

  const fetchDepartment = async () => {
    try {
      const response = await getDepartments(UID);

      setDepartment(response);
      //(Department, "Filtered Pages");
    } catch (error) {
      console.error("Error fetching cate:", error);
    }
  };

  const fetchfilterProfitecenter = async () => {
    try {
      const response = await getProfitCenter(UID);

      setFilterProfitcenter(response);
      //(FilterProfitcenter, "Filtered Pages");
    } catch (error) {
      console.error("Error fetching cate:", error);
    }
  };

  const generateMultipleVouchers = async (payrollDataArray, userId) => {
    try {
      const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });
      const pageWidth = 210; // A4 width in mm
      const pageHeight = 297; // A4 height in mm
      const voucherWidth = 95; // Width for each voucher
      const voucherHeight = 67; // Height adjusted for 8 vouchers (4 rows)
      const marginX = 10;
      const marginY = 10;
      const spacingX = 5; // Space between columns
      const spacingY = 5; // Space between rows
      const columns = 2;
      const rows = 4; // 4 rows to fit 8 vouchers
      const slipsPerPage = columns * rows;

      // Function to convert image to base64
      const getBase64Image = (imgUrl) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = "Anonymous";
          img.src = imgUrl;
          img.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            const dataURL = canvas.toDataURL("image/png");
            resolve(dataURL);
          };
          img.onerror = (err) => reject(err);
        });
      };

      // Load auth_bg image
      let authBgBase64;
      try {
        authBgBase64 = await getBase64Image(auth_bg);
      } catch (error) {
        console.error("Error loading auth_bg image:", error);
        authBgBase64 = null; // Fallback if image fails to load
      }

      // Number to words function
      function numberToWords(num) {
        const single = [
          "",
          "one",
          "two",
          "three",
          "four",
          "five",
          "six",
          "seven",
          "eight",
          "nine",
        ];
        const teens = [
          "ten",
          "eleven",
          "twelve",
          "thirteen",
          "fourteen",
          "fifteen",
          "sixteen",
          "seventeen",
          "eighteen",
          "nineteen",
        ];
        const tens = [
          "",
          "",
          "twenty",
          "thirty",
          "forty",
          "fifty",
          "sixty",
          "seventy",
          "eighty",
          "ninety",
        ];
        if (num === 0) return "zero";
        function convertLessThanThousand(n) {
          if (n === 0) return "";
          else if (n < 10) return single[n];
          else if (n < 20) return teens[n - 10];
          else if (n < 100)
            return (
              tens[Math.floor(n / 10)] +
              (n % 10 !== 0 ? " " + single[n % 10] : "")
            );
          else
            return (
              single[Math.floor(n / 100)] +
              " hundred" +
              (n % 100 !== 0 ? " " + convertLessThanThousand(n % 100) : "")
            );
        }
        let words = "";
        if (num >= 100000) {
          words += convertLessThanThousand(Math.floor(num / 100000)) + " lakh ";
          num %= 100000;
        }
        if (num >= 1000) {
          words +=
            convertLessThanThousand(Math.floor(num / 1000)) + " thousand ";
          num %= 1000;
        }
        if (num > 0) {
          words += convertLessThanThousand(num);
        }
        return words.trim();
      }

      // Date formatting
      const currentDate = new Date();
      const formattedDate = `${currentDate
        .getDate()
        .toString()
        .padStart(2, "0")}/${(currentDate.getMonth() + 1)
        .toString()
        .padStart(2, "0")}/${currentDate.getFullYear().toString().slice(-2)}`;

      // Voucher number handling
      const getLastUsedVoucherNumber = async () => {
        try {
          const response = await GetNextVoucherNumber();
          const nextVoucherNo =
            response?.data?.data?.result?.LastVoucherNo ||
            response?.data?.voucherNo;
          return nextVoucherNo;
        } catch (error) {
          console.error("Error fetching voucher number:", error);
          return 1;
        }
      };

      const lastVoucherNumber = await getLastUsedVoucherNumber();
      let currentVoucherNumber = (lastVoucherNumber ?? 0) + 1;
      const usedVoucherNumbers = new Set();

      const getUniqueVoucherNumber = () => {
        const prefix = "DV-";
        let paddedNumber, voucherNumber;
        do {
          paddedNumber = currentVoucherNumber.toString().padStart(6, "0");
          voucherNumber = `${prefix}${paddedNumber}`;
          currentVoucherNumber++;
        } while (usedVoucherNumbers.has(voucherNumber));
        usedVoucherNumbers.add(voucherNumber);
        return voucherNumber;
      };

      const drawVoucherSlip = (data, x, y, width, height) => {
        const voucherNo = getUniqueVoucherNumber();
        const startDate = new Date(data?.StartDate);
        const FormattedFromDate = `${startDate
          .getDate()
          .toString()
          .padStart(2, "0")}/${(startDate.getMonth() + 1)
          .toString()
          .padStart(2, "0")}/${startDate.getFullYear().toString().slice(-2)}`;
        const EndDate = new Date(data?.EndDate);
        const FormattedEndDate = `${EndDate.getDate()
          .toString()
          .padStart(2, "0")}/${(EndDate.getMonth() + 1)
          .toString()
          .padStart(2, "0")}/${EndDate.getFullYear().toString().slice(-2)}`;

        // Draw voucher background and border
        doc.setFillColor(240, 248, 255);
        doc.rect(x, y, width, height, "F");
        doc.setDrawColor(0, 51, 102);
        doc.setLineWidth(0.5);
        doc.rect(x, y, width, height, "S");

        const padding = 5;
        const contentX = x + padding;
        const contentWidth = width - padding * 2;

        // Add auth_bg icon
        if (authBgBase64) {
          try {
            doc.addImage(authBgBase64, "PNG", contentX, y + 3, 8, 8); // Smaller icon size for compact layout
          } catch (error) {
            console.error("Error adding auth_bg image to PDF:", error);
          }
        }

        // Header
        doc.setFont("helvetica", "bold");
        doc.setFontSize(7);
        doc.setTextColor(0, 51, 102);
        doc.text(
          `DEBIT VOUCHER ${FormattedFromDate} - ${FormattedEndDate}`,
          x + width / 2,
          y + 7,
          { align: "center" },
        );
        doc.setFontSize(5);
        doc.text(
          `${companyDetails.Name.toUpperCase()}`,
          x + width / 2,
          y + 10,
          { align: "center" },
        );

        // Date and Voucher Number
        doc.setFontSize(5);
        doc.setFont("helvetica", "normal");
        doc.text(`Date: ${formattedDate}`, contentX, y + 14);
        doc.text(`Voucher No: ${voucherNo}`, x + width - 25, y + 14);

        // Head of account
        doc.text("Head of account:", contentX, y + 18);
        doc.setFont("helvetica", "bold");
        doc.text(data.DepartmentName || "_", contentX + 20, y + 18);

        // Employee Details
        doc.setFont("helvetica", "bold");
        doc.text("Employee Details:", contentX, y + 22);
        doc.setFont("helvetica", "normal");
        doc.text(`Name: ${data.Name || "N/A"}`, contentX, y + 26);
        doc.text(`Code: ${data.Code || "N/A"}`, contentX + 45, y + 26);
        doc.text(
          `Position: ${data.DesignationName || "Staff"}`,
          contentX,
          y + 30,
        );

        // Payment Details
        doc.setFont("helvetica", "bold");
        doc.text("Payment Details:", contentX, y + 34);
        doc.setFont("helvetica", "normal");
        doc.text(
          `Days: ${data?.EmployeeTotalWorkingDays || 0}`,
          contentX,
          y + 38,
        );
        doc.text(
          `Wage: Rs. ${data.CurrentBasicPay?.toFixed(2) || "0.00"}`,
          contentX + 45,
          y + 38,
        );

        // Net Amount
        doc.setFont("helvetica", "bold");
        doc.setFontSize(6);
        doc.text(
          `Net: Rs. ${data.NetSalary?.toFixed(2) || "0.00"}`,
          contentX,
          y + 42,
        );

        // Amount in words
        doc.setFontSize(5);
        doc.setFont("helvetica", "bold");
        doc.text("In words:", contentX, y + 46);
        doc.setFont("helvetica", "normal");
        const amountInWords = numberToWords(Math.floor(data.NetSalary || 0));
        const wrappedText = doc.splitTextToSize(
          `(${amountInWords} rupees)`,
          contentWidth - 10,
        );
        doc.text(wrappedText, contentX, y + 49);

        // Signature section
        const signatureStartY = y + 54;
        doc.setFont("helvetica", "normal");
        doc.setFontSize(4);

        // Define columns for alignment
        const col1X = contentX;
        const col2X = contentX + 30;
        const col3X = contentX + 60;

        // Row 1
        doc.text("Recipient:", col1X, signatureStartY);
        doc.line(col1X, signatureStartY + 1, col1X + 20, signatureStartY + 1);
        doc.text("Section:", col2X, signatureStartY);
        doc.line(col2X, signatureStartY + 1, col2X + 20, signatureStartY + 1);

        // Row 2
        const row2Y = signatureStartY + 5;
        doc.text("Clerk:", col1X, row2Y);
        doc.line(col1X, row2Y + 1, col1X + 20, row2Y + 1);
        doc.text("Sreekaryakar:", col2X, row2Y);
        doc.line(col2X, row2Y + 1, col2X + 20, row2Y + 1);

        // Row 3
        const row3Y = signatureStartY + 10;
        doc.text("Accounts:", col1X, row3Y);
        doc.line(col1X, row3Y + 1, col1X + 20, row3Y + 1);
        doc.text("Treasurer:", col2X, row3Y);
        doc.line(col2X, row3Y + 1, col2X + 20, row3Y + 1);
        doc.text("Secretary:", col3X, row3Y);
        doc.line(col3X, row3Y + 1, col3X + 20, row3Y + 1);

        return voucherNo;
      };

      const generatedVoucherNumbers = [];
      const voucherUpdates = [];
      let currentPage = 1;

      for (let i = 0; i < payrollDataArray.length; i++) {
        const pageIndex = Math.floor(i / slipsPerPage);
        const positionOnPage = i % slipsPerPage;
        const rowOnPage = Math.floor(positionOnPage / columns);
        const colOnPage = positionOnPage % columns;

        if (pageIndex + 1 > currentPage) {
          doc.addPage();
          currentPage++;
        }

        const x = marginX + colOnPage * (voucherWidth + spacingX);
        const y = marginY + rowOnPage * (voucherHeight + spacingY);
        const voucherNo = drawVoucherSlip(
          payrollDataArray[i],
          x,
          y,
          voucherWidth,
          voucherHeight,
        );

        generatedVoucherNumbers.push(voucherNo);

        if (payrollDataArray[i].Id) {
          voucherUpdates.push({
            Id: payrollDataArray[i].Id,
            VoucherNo: voucherNo,
            UserId: userId,
          });
        }
      }

      const totalPages = Math.ceil(payrollDataArray.length / slipsPerPage);
      for (let p = 0; p < totalPages; p++) {
        doc.setPage(p + 1);
        doc.setFontSize(8);
        doc.text(
          `Page ${p + 1} of ${totalPages}`,
          pageWidth - 25,
          pageHeight - 10,
        );
      }

      doc.save("debit_vouchers.pdf");

      // Update voucher numbers in database
      try {
        if (voucherUpdates.length > 0) {
          const updatePayload = {
            VoucherUpdates: voucherUpdates,
            UserId: userId,
          };
          const updateResponse = await UpdateVoucherNumber(updatePayload);
        }
      } catch (error) {
        console.error("Error updating voucher numbers in database:", error);
      }

      fetchData();

      return {
        success: true,
        message: `Generated ${payrollDataArray.length} voucher(s) across ${totalPages} page(s).`,
        voucherNumbers: generatedVoucherNumbers,
        nextAvailableNumber: currentVoucherNumber,
      };
    } catch (error) {
      console.error("Error generating vouchers PDF:", error);
      alert("Failed to generate vouchers PDF. Please try again.");
      return {
        success: false,
        message: error.message,
      };
    }
  };
  // Individual Employee Voucher Generation Function
  const generateIndividualVoucher = async (employeeData, userId) => {
    try {
      const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });
      const pageWidth = 210; // A4 width in mm
      const pageHeight = 297; // A4 height in mm
      const voucherWidth = 180; // Width for individual voucher
      const voucherHeight = 150; // Height to fit all signatures within border
      const marginX = 15;
      const marginY = 20;

      // Function to convert image to base64 (if needed)
      const getBase64Image = (imgUrl) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = "Anonymous";
          img.src = imgUrl;
          img.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            const dataURL = canvas.toDataURL("image/png");
            resolve(dataURL);
          };
          img.onerror = (err) => reject(err);
        });
      };

      // Assume auth_bg is an imported image (e.g., import auth_bg from './path/to/image.png')
      // If auth_bg is a URL or file path, convert it to base64
      let authBgBase64;
      try {
        authBgBase64 = await getBase64Image(auth_bg);
      } catch (error) {
        console.error("Error loading auth_bg image:", error);
        authBgBase64 = null; // Fallback if image fails to load
      }

      function numberToWords(num) {
        const single = [
          "",
          "one",
          "two",
          "three",
          "four",
          "five",
          "six",
          "seven",
          "eight",
          "nine",
        ];
        const teens = [
          "ten",
          "eleven",
          "twelve",
          "thirteen",
          "fourteen",
          "fifteen",
          "sixteen",
          "seventeen",
          "eighteen",
          "nineteen",
        ];
        const tens = [
          "",
          "",
          "twenty",
          "thirty",
          "forty",
          "fifty",
          "sixty",
          "seventy",
          "eighty",
          "ninety",
        ];
        if (num === 0) return "zero";
        function convertLessThanThousand(n) {
          if (n === 0) return "";
          else if (n < 10) return single[n];
          else if (n < 20) return teens[n - 10];
          else if (n < 100)
            return (
              tens[Math.floor(n / 10)] +
              (n % 10 !== 0 ? " " + single[n % 10] : "")
            );
          else
            return (
              single[Math.floor(n / 100)] +
              " hundred" +
              (n % 100 !== 0 ? " " + convertLessThanThousand(n % 100) : "")
            );
        }
        let words = "";
        if (num >= 100000) {
          words += convertLessThanThousand(Math.floor(num / 100000)) + " lakh ";
          num %= 100000;
        }
        if (num >= 1000) {
          words +=
            convertLessThanThousand(Math.floor(num / 1000)) + " thousand ";
          num %= 1000;
        }
        if (num > 0) {
          words += convertLessThanThousand(num);
        }
        return words.trim();
      }

      const currentDate = new Date();
      const formattedDate = `${currentDate
        .getDate()
        .toString()
        .padStart(2, "0")}/${(currentDate.getMonth() + 1)
        .toString()
        .padStart(2, "0")}/${currentDate.getFullYear().toString().slice(-2)}`;
      const startDate = new Date(employeeData?.StartDate);
      const FormattedFromDate = `${startDate
        .getDate()
        .toString()
        .padStart(2, "0")}/${(startDate.getMonth() + 1)
        .toString()
        .padStart(2, "0")}/${startDate.getFullYear().toString().slice(-2)}`;
      const EndDate = new Date(employeeData?.EndDate);
      const FormattedEndDate = `${EndDate.getDate()
        .toString()
        .padStart(2, "0")}/${(EndDate.getMonth() + 1)
        .toString()
        .padStart(2, "0")}/${EndDate.getFullYear().toString().slice(-2)}`;

      const getLastUsedVoucherNumber = async () => {
        try {
          const response = await GetNextVoucherNumber();
          const nextVoucherNo =
            response?.data?.data?.result?.LastVoucherNo ||
            response?.data?.voucherNo;
          return nextVoucherNo;
        } catch (error) {
          console.error("Error fetching voucher number:", error);
          return 1;
        }
      };

      const lastVoucherNumber = await getLastUsedVoucherNumber();
      let currentVoucherNumber = (lastVoucherNumber ?? 0) + 1;
      const usedVoucherNumbers = new Set();

      const getUniqueVoucherNumber = () => {
        const prefix = "DV-";
        let paddedNumber, voucherNumber;
        do {
          paddedNumber = currentVoucherNumber.toString().padStart(6, "0");
          voucherNumber = `${prefix}${paddedNumber}`;
          currentVoucherNumber++;
        } while (usedVoucherNumbers.has(voucherNumber));
        usedVoucherNumbers.add(voucherNumber);
        return voucherNumber;
      };

      const drawIndividualVoucher = (data, x, y, width, height) => {
        const voucherNo = getUniqueVoucherNumber();

        // Draw voucher background and border
        doc.setFillColor(240, 248, 255);
        doc.rect(x, y, width, height, "F");
        doc.setDrawColor(0, 51, 102);
        doc.setLineWidth(0.5);
        doc.rect(x, y, width, height, "S");

        const padding = 8;
        const contentX = x + padding;
        const contentWidth = width - padding * 2;

        // Add auth_bg icon in the header (top-left corner)
        if (authBgBase64) {
          try {
            doc.addImage(authBgBase64, "PNG", contentX, y + 5, 15, 15); // Icon size: 15mm x 15mm
          } catch (error) {
            console.error("Error adding auth_bg image to PDF:", error);
          }
        }

        // Header
        doc.setFont("helvetica", "bold");
        doc.setFontSize(12);
        doc.setTextColor(0, 51, 102);
        // Adjust title position to avoid overlapping with icon
        doc.text(
          `DEBIT VOUCHER From ${FormattedFromDate} To ${FormattedEndDate}`,
          x + width / 2,
          y + 12,
          { align: "center" },
        );

        doc.setFontSize(9);
        doc.text(
          `${companyDetails.Name.toUpperCase()}`,
          x + width / 2,
          y + 18,
          { align: "center" },
        );

        // Date and Voucher Number
        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");
        doc.text(`Date: ${formattedDate}`, contentX, y + 28);
        doc.text(`Voucher No: ${voucherNo}`, x + width - 50, y + 28);

        // Head of account
        doc.text("Head of account:", contentX, y + 35);
        doc.setFont("helvetica", "bold");
        doc.text(data.DepartmentName || "_", contentX + 35, y + 35);

        // Employee Details
        doc.setFont("helvetica", "bold");
        doc.text("Employee Details:", contentX, y + 43);
        doc.setFont("helvetica", "normal");
        doc.text(`Name: ${data.Name || "N/A"}`, contentX, y + 50);
        doc.text(`Code: ${data.Code || "N/A"}`, contentX + 80, y + 50);
        doc.text(
          `Position: ${data.DesignationName || "Staff"}`,
          contentX,
          y + 57,
        );

        // Payment Details
        doc.setFont("helvetica", "bold");
        doc.text("Payment Details:", contentX, y + 65);
        doc.setFont("helvetica", "normal");
        doc.text(
          `Days worked: ${data?.EmployeeTotalWorkingDays || 0}`,
          contentX,
          y + 72,
        );
        doc.text(
          `Daily wage: Rs. ${data.CurrentBasicPay?.toFixed(2) || "0.00"}`,
          contentX + 60,
          y + 72,
        );

        // Net Amount
        doc.setFont("helvetica", "bold");
        doc.setFontSize(9);
        doc.text(
          `Net Amount: Rs. ${data.NetSalary?.toFixed(2) || "0.00"}`,
          contentX,
          y + 80,
        );

        // Amount in words
        doc.setFontSize(8);
        doc.setFont("helvetica", "bold");
        doc.text("Amount in words:", contentX, y + 88);
        doc.setFont("helvetica", "normal");
        const amountInWords = numberToWords(Math.floor(data.NetSalary || 0));
        const wrappedText = doc.splitTextToSize(
          `(${amountInWords} rupees only)`,
          contentWidth - 10,
        );
        doc.text(wrappedText, contentX, y + 93);

        // Signature section
        const signatureStartY = y + 103; // Adjusted to fit within border
        doc.setFont("helvetica", "normal");
        doc.setFontSize(7);

        // Define columns for alignment
        const col1X = contentX;
        const col2X = contentX + 60;
        const col3X = contentX + 120;

        // Row 1
        doc.text("Recipient:", col1X, signatureStartY);
        doc.line(col1X, signatureStartY + 2, col1X + 45, signatureStartY + 2);

        doc.text("Section-in charge:", col2X, signatureStartY);
        doc.line(col2X, signatureStartY + 2, col2X + 45, signatureStartY + 2);

        // Row 2
        const row2Y = signatureStartY + 12;
        doc.text("Clerk:", col1X, row2Y);
        doc.line(col1X, row2Y + 2, col1X + 45, row2Y + 2);

        doc.text("Sreekaryakar:", col2X, row2Y);
        doc.line(col2X, row2Y + 2, col2X + 45, row2Y + 2);

        // Row 3
        const row3Y = signatureStartY + 24;
        doc.text("Accounts Officer:", col1X, row3Y);
        doc.line(col1X, row3Y + 2, col1X + 45, row3Y + 2);

        doc.text("Treasurer:", col2X, row3Y);
        doc.line(col2X, row3Y + 2, col2X + 45, row3Y + 2);

        doc.text("Secretary:", col3X, row3Y);
        doc.line(col3X, row3Y + 2, col3X + 45, row3Y + 2);

        // Row 4
        const row4Y = signatureStartY + 36;
        doc.text("Enter Voucher Number:", col1X, row4Y);
        doc.line(col1X, row4Y + 2, col1X + 45, row4Y + 2);

        doc.text("Remarks:", col2X, row4Y);
        doc.line(col2X, row4Y + 2, col2X + 45, row4Y + 2);

        doc.text("Employee Signature:", col3X, row4Y);
        doc.line(col3X, row4Y + 2, col3X + 45, row4Y + 2);

        return voucherNo;
      };

      const voucherNumber = drawIndividualVoucher(
        employeeData,
        marginX,
        marginY,
        voucherWidth,
        voucherHeight,
      );

      const fileName = `voucher_${
        employeeData.Name?.replace(/[^a-zA-Z0-9]/g, "_") || "employee"
      }_${voucherNumber}.pdf`;
      doc.save(fileName);

      // Call the UpdateVoucherNumber API to update the database
      try {
        if (employeeData.Id && userId) {
          const updatePayload = {
            Id: employeeData.Id,
            VoucherNo: voucherNumber,
            UserId: userId,
          };
          const updateResponse = await UpdateVoucherNumber(updatePayload);
        }
      } catch (error) {
        console.error("Error updating voucher number in database:", error);
      }

      fetchData();

      return {
        success: true,
        message: `Generated individual voucher for ${employeeData.Name}`,
        voucherNumber: voucherNumber,
        fileName: fileName,
      };
    } catch (error) {
      alert("Failed to generate individual voucher. Please try again.");
      return {
        success: false,
        message: error.message,
      };
    }
  };

  // Function to get employee data and generate voucher
  const generateEmployeeVoucher = async (empId) => {
    // You'll need to fetch the employee data based on empId
    // This is a placeholder - replace with your actual data fetching logic
    const employeeData = PayrollData.find((emp) => emp.EmpId === empId);

    if (employeeData) {
      const result = generateIndividualVoucher(employeeData, UID);
    }
  };

  const fetchData = async () => {
    try {
      const payload = {
        option: selectedOption,
        fromDate,
        toDate,
        UserId: UID, // Ensure UID is passed correctly
      };

      // Call the API function to get payroll details
      const response = await GetPayrolldetailsforreport(payload);
      console.log(
        "Payroll Data Total Additions:",
        response.data.data[0].reduce(
          (sum, el) => sum + (el.TotalAdditions || 0),
          0,
        ),
        response.data.data[0].reduce(
          (sum, el) => sum + (el.TotalDeductions || 0),
          0,
        ),
        response.data.data[0].reduce((sum, el) => sum + (el.NetSalary || 0), 0),
      );
      // Assuming the API returns the data in `response.data`
      setPayrollData(response.data.data[0]);
      setAdditionsDeductions(response.data.data[1]);
      //console.log("Payrolsdsadl Data:", response);
      setSelectedEmployees(new Array(response.data.data[0].length).fill(false));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getPFData = async () => {
    try {
      const payload = {
        option: selectedOption,
        option: selectedOption,
        fromDate: fromDate || new Date().toISOString().split("T")[0], // Formats to YYYY-MM-DD
        toDate: toDate || new Date().toISOString().split("T")[0], // Formats to YYYY-MM-DD
        UserId: UID, // Ensure UID is passed correctly
      };

      // Call the API function to get payroll details
      const response = await getPfData(payload);
      setPfData(response.data.data);
      //console.log("Payrolsdsadl Data:", response);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchESIstatement = async () => {
    try {
      const payload = {
        option: selectedOption,
        option: selectedOption,
        fromDate: fromDate || new Date().toISOString().split("T")[0], // Formats to YYYY-MM-DD
        toDate: toDate || new Date().toISOString().split("T")[0], // Formats to YYYY-MM-DD
        UserId: UID, // Ensure UID is passed correctly
      };

      // Call the API function to get payroll details
      const response = await getEsiData(payload);
      setEsiData(response.data.data);
      //console.log("Payrolsdsadl Data:", response);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleMonthlyClick = () => {
    setShowMonthly(true);
  };
  const handleMonthlyClickback = () => {
    setShowMonthly(false);
  };

  const handleViewClick = () => {
    localStorage.removeItem("selectedPayrollColumns");
    fetchData();
    getPFData();
    fetchESIstatement();
    fetchparollReportColumns();
  };

  const handleSelectChange = (event) => {
    const selectedValue = event.target.value; // Access the selected value correctly
    //console.log("Selected Option:", selectedValue);

    setSelectedOption(selectedValue); // Update the state with the selected value
  };

  const toggleAdditionsModal = (Id) => {
    //console.log(Id, "ghjkds");

    setEmployeeId(Id);
    setAdditionsModalOpen(!isAdditionsModalOpen);
  };

  const toggleDeductionsModal = (Id) => {
    setEmployeeId(Id);
    setDeductionsModalOpen(!isDeductionsModalOpen);
  };

  const GenerateAllPayslips = () => {
    const date = new Date(fromDate);

    // Use Intl.DateTimeFormat for formatted date string
    const monthNameAndYear = new Intl.DateTimeFormat("en-US", {
      month: "long",
      year: "numeric",
    }).format(date);

    // Helper function for proper rounding and formatting
    const formatCurrency = (amount) => {
      // Round to nearest integer
      return Math.round(Number(amount)).toFixed(2);
    };

    // Helper function to safely display text
    const safeText = (value) => value || "N/A";

    // Helper function to convert numbers to words
    const numberToWords = (num) => {
      // Round the number before converting to words
      num = Math.round(num);
      const ones = [
        "",
        "One",
        "Two",
        "Three",
        "Four",
        "Five",
        "Six",
        "Seven",
        "Eight",
        "Nine",
        "Ten",
        "Eleven",
        "Twelve",
        "Thirteen",
        "Fourteen",
        "Fifteen",
        "Sixteen",
        "Seventeen",
        "Eighteen",
        "Nineteen",
      ];
      const tens = [
        "",
        "",
        "Twenty",
        "Thirty",
        "Forty",
        "Fifty",
        "Sixty",
        "Seventy",
        "Eighty",
        "Ninety",
      ];

      if (num === 0) return "Zero";

      const rupees = Math.floor(num); // Integer part for rupees
      const paise = Math.round((num - rupees) * 100); // Fractional part converted to paise

      const convertToWords = (n) => {
        if (n === 0) return "";
        if (n < 20) return ones[n];
        if (n < 100) {
          return (
            tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + ones[n % 10] : "")
          );
        }
        if (n < 1000) {
          return (
            ones[Math.floor(n / 100)] +
            " Hundred" +
            (n % 100 !== 0 ? " and " + convertToWords(n % 100) : "")
          );
        }
        if (n < 100000) {
          return (
            convertToWords(Math.floor(n / 1000)) +
            " Thousand" +
            (n % 1000 !== 0 ? " " + convertToWords(n % 1000) : "")
          );
        }
        if (n < 10000000) {
          return (
            convertToWords(Math.floor(n / 100000)) +
            " Lakh" +
            (n % 100000 !== 0 ? " " + convertToWords(n % 100000) : "")
          );
        }
        return (
          convertToWords(Math.floor(n / 10000000)) +
          " Crore" +
          (n % 10000000 !== 0 ? " " + convertToWords(n % 10000000) : "")
        );
      };

      let result = convertToWords(rupees);
      if (paise > 0) {
        result += ` and ${convertToWords(paise)} `;
      }
      return result + " ";
    };

    // Create a new PDF document
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const margin = 5;
    const gapBetweenSlips = 3; // Additional gap between payslips

    // Calculate dimensions for 2 columns
    const gridWidth = (pageWidth - margin * 3) / 2;
    const minGridHeight = 40; // Minimum height for a payslip

    let currentX = margin;
    let currentY = margin;
    let slipCount = 0;

    // Track heights of payslips in current row for proper spacing
    let leftColumnHeight = 0;
    let rightColumnHeight = 0;

    filterdPayrollData?.forEach((employee, index) => {
      // Filter additions and deductions for the employee
      const employeeAdditions = additionsDeductions.filter(
        (ad) =>
          ad.EmpId === employee.EmpId &&
          ["Addition type", "Addition"].includes(ad.ComponentType),
      );

      const employeeDeductions = additionsDeductions.filter(
        (ad) =>
          ad.EmpId === employee.EmpId &&
          ["Deduction type", "Deduction"].includes(ad.ComponentType),
      );

      // Sort the additions to ensure "Basic" appears first
      const sortedAdditions = [...employeeAdditions].sort((a, b) => {
        // Check if component name contains "basic" (case insensitive)
        const aIsBasic = a.ComponentName.toLowerCase().includes("basic");
        const bIsBasic = b.ComponentName.toLowerCase().includes("basic");

        if (aIsBasic && !bIsBasic) return -1; // a comes first
        if (!aIsBasic && bIsBasic) return 1; // b comes first
        return 0; // keep original order
      });

      const totalAdditions = sortedAdditions.reduce((total, ad) => {
        const amount =
          ad.ValueType === "Percentage"
            ? (Number(ad.BaseAmount || 0) * Number(ad.PercentageValue || 0)) /
              100
            : Number(ad.CalculatedAmount || 0);
        return total + (isNaN(amount) ? 0 : amount);
      }, 0);

      const totalDeductions = employeeDeductions.reduce((total, ded) => {
        const amount =
          ded.ValueType === "Percentage" && ded.BaseAmount < 15000
            ? (Number(ded.BaseAmount || 0) * Number(ded.PercentageValue || 0)) /
              100
            : Number(ded.CalculatedAmount || 0);
        return total + (isNaN(amount) ? 0 : amount);
      }, 0);

      const basicPay = Number(employee.CurrentBasicPay) || 0;
      const workingDays = Number(employee.EmployeeTotalWorkingDays) || 0;
      const grossEarnings = Math.round(totalAdditions);
      const netPay = Math.round(employee?.NetSalary);
      const netPayInWords = numberToWords(netPay) + "";

      // Calculate max rows needed for dynamic grid height calculation
      const maxRows = Math.max(
        sortedAdditions.length,
        employeeDeductions.length,
        3,
      ); // Minimum 3 rows
      const rowHeight = 3;

      // Calculate dynamic grid height based on content
      const headerHeight = 6;
      const detailsSectionHeight = 20; // Increased to accommodate row gaps
      const tableHeaderHeight = 4;
      const totalSectionHeight = 6;
      const netPaySectionHeight = 4;
      const wordsHeight = 4;
      const signatureHeight = 5;

      const dynamicGridHeight =
        headerHeight +
        detailsSectionHeight +
        tableHeaderHeight +
        maxRows * rowHeight +
        totalSectionHeight +
        netPaySectionHeight +
        wordsHeight +
        signatureHeight +
        2; // +2 for padding

      const gridHeight = Math.max(minGridHeight, dynamicGridHeight);

      // Check if we need a new page before drawing
      if (currentY + gridHeight > pageHeight - margin) {
        doc.addPage();
        currentX = margin;
        currentY = margin;
        leftColumnHeight = 0;
        rightColumnHeight = 0;
        slipCount = 0;
      }

      // Draw outer border for the payslip
      doc.setLineWidth(0.3);
      doc.rect(currentX, currentY, gridWidth, gridHeight);
      doc.setLineWidth(0.1);

      // Add header with border
      doc.rect(currentX, currentY, gridWidth, 6);

      doc.setFont("helvetica", "bold");
      doc.setFontSize(7);
      doc.text(
        `${companyDetails?.Name.toUpperCase()}`,
        currentX + gridWidth / 2,
        currentY + 3,
        { align: "center" },
      );

      // Subtitle
      doc.setFontSize(6);
      doc.text(
        `SALARY SLIP ${monthNameAndYear}`,
        currentX + gridWidth / 2,
        currentY + 5,
        { align: "center" },
      );

      // Employee details section with border - FIXED VERSION
      doc.rect(currentX, currentY + 6, gridWidth, detailsSectionHeight);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(5);

      // Improved helper function to wrap text and return lines
      const wrapText = (text, maxWidth) => {
        if (!text) return [""];

        const words = text.toString().split(" ");
        if (words.length === 0) return [""];

        const lines = [];
        let currentLine = words[0] || "";

        for (let i = 1; i < words.length; i++) {
          const word = words[i];
          const testLine = currentLine + " " + word;
          const testWidth = doc.getTextWidth(testLine);

          if (testWidth < maxWidth && testLine.length < 50) {
            currentLine = testLine;
          } else {
            lines.push(currentLine);
            currentLine = word;
          }
        }
        lines.push(currentLine);
        return lines.filter((line) => line.trim().length > 0);
      };

      // Define two columns with better spacing
      const col1Width = gridWidth * 0.58;
      const col2Width = gridWidth * 0.38;
      const col1X = currentX + 2;
      const col2X = currentX + col1Width + 4;

      // Starting Y position inside rectangle
      let textY = currentY + 9;
      const lineGap = 1.8;
      const rowGap = 2.0;

      // COLUMN 1: Name, Designation, Department
      let col1Y = textY;

      // Name
      const nameText = `Name: ${safeText(employee.Name)} (${safeText(
        employee.Code,
      )})`;
      const nameLines = wrapText(nameText, col1Width - 6);
      nameLines.forEach((line, index) => {
        doc.text(line, col1X, col1Y + index * lineGap);
      });
      col1Y += Math.max(nameLines.length * lineGap, lineGap) + rowGap;

      // Designation
      const designationText = `Desg: ${safeText(employee.DesignationName)}`;
      const designationLines = wrapText(designationText, col1Width - 6);
      designationLines.forEach((line, index) => {
        doc.text(line, col1X, col1Y + index * lineGap);
      });
      col1Y += Math.max(designationLines.length * lineGap, lineGap) + rowGap;

      // Department
      const departmentText = `Dept: ${safeText(employee.DepartmentName)}`;
      const departmentLines = wrapText(departmentText, col1Width - 6);
      departmentLines.forEach((line, index) => {
        doc.text(line, col1X, col1Y + index * lineGap);
      });

      // COLUMN 2: Attendance and Leave Details
      let col2Y = textY;

      // Attendance
      const attendanceText = `Attendance: ${safeText(workingDays.toString())}`;
      doc.text(attendanceText, col2X, col2Y);
      col2Y += lineGap + rowGap;

      // Calculate LOP
      const lopValue = Math.max(
        0,
        (employee?.TotalWorkingDays ?? 0) -
          (employee?.PayrollDays ?? employee?.TotalWorkingDays ?? 0) -
          employee?.TotalHalfDay ??
          employee?.TotalHalfDay ??
          0,
      );

      // Leave details
      const leaveDetailsText = `Deduction: HD:${safeText(
        employee?.TotalHalfDay,
      )} | SL:${safeText(employee?.HalfSickLeave)} | LC:${safeText(
        employee?.LateCut,
      )} | LOP:${safeText(lopValue, "ss")}`;

      doc.setFontSize(4);
      const leaveLines = wrapText(leaveDetailsText, col2Width - 4);
      leaveLines.forEach((line, index) => {
        doc.text(line, col2X, col2Y + index * 1.5);
      });
      col2Y += Math.max(leaveLines.length * 1.5, 1.5) + rowGap;

      // Leave Types
      doc.setFontSize(5);
      const leaveTypeText = `Leaves: ${safeText(employee.LeaveTypes)}`;
      const leaveTypeLines = wrapText(leaveTypeText, col2Width - 4);
      leaveTypeLines.forEach((line, index) => {
        doc.text(line, col2X, col2Y + index * lineGap);
      });

      col2Y += Math.max(leaveLines.length * 1.5, 1.5) + rowGap;
      doc.setFontSize(4);

      const halfdaywithoutlop = `HalfDay Paid: ${safeText(
        employee?.TotalHalfDay_NOT_HalfDaysLOP_COUNT,
      )}`;
      const halfdaywithoutlopLines = wrapText(halfdaywithoutlop, col2Width - 4);
      halfdaywithoutlopLines.forEach((line, index) => {
        doc.text(line, col2X, col2Y + index * lineGap);
      });

      // Reset font size for subsequent content
      doc.setFontSize(5);

      // Reset font size for subsequent content
      doc.setFontSize(5);

      // Earnings and Deductions Table Headers
      const tableY = currentY + 6 + detailsSectionHeight; // Use exact calculation
      const columnWidth = gridWidth / 2;

      // Table header borders
      doc.rect(currentX, tableY, columnWidth, 4);
      doc.rect(currentX + columnWidth, tableY, columnWidth, 4);

      // Table headers text
      doc.setFont("helvetica", "bold");
      doc.setFontSize(5);
      doc.text("EARNINGS", currentX + columnWidth / 2, tableY + 2.5, {
        align: "center",
      });
      doc.text(
        "DEDUCTIONS",
        currentX + columnWidth + columnWidth / 2,
        tableY + 2.5,
        { align: "center" },
      );

      // Draw table cells for items
      for (let i = 0; i < maxRows; i++) {
        const cellY = tableY + 4 + i * rowHeight;

        // Draw cell borders
        doc.rect(currentX, cellY, columnWidth, rowHeight);
        doc.rect(currentX + columnWidth, cellY, columnWidth, rowHeight);

        doc.setFont("helvetica", "normal");
        doc.setFontSize(5);

        // Left side (Earnings) - Using sortedAdditions to display Basic first
        if (i < sortedAdditions.length) {
          const addition = sortedAdditions[i];
          const componentName =
            addition.ComponentName.length > 15
              ? addition.ComponentName.substring(0, 15) + "..."
              : addition.ComponentName;

          doc.text(safeText(componentName), currentX + 1, cellY + 2);
          doc.text(
            formatCurrency(addition.CalculatedAmount),
            currentX + columnWidth - 1,
            cellY + 2,
            { align: "right" },
          );
        }

        // Right side (Deductions)
        if (i < employeeDeductions.length) {
          const deduction = employeeDeductions[i];
          const componentName =
            deduction.ComponentName.length > 15
              ? deduction.ComponentName.substring(0, 15) + "..."
              : deduction.ComponentName;

          doc.text(
            safeText(componentName),
            currentX + columnWidth + 1,
            cellY + 2,
          );
          doc.text(
            formatCurrency(deduction.CalculatedAmount),
            currentX + gridWidth - 1,
            cellY + 2,
            { align: "right" },
          );
        }
      }

      // Total section
      const totalY = tableY + 4 + maxRows * rowHeight;

      // Draw total section borders
      doc.rect(currentX, totalY, columnWidth, totalSectionHeight);
      doc.rect(currentX + columnWidth, totalY, columnWidth, totalSectionHeight);

      // Draw totals text
      doc.setFont("helvetica", "bold");
      doc.setFontSize(5);
      doc.text("Total:", currentX + 1, totalY + 2);
      doc.text(
        formatCurrency(grossEarnings),
        currentX + columnWidth - 1,
        totalY + 2,
        { align: "right" },
      );

      doc.text("Total:", currentX + columnWidth + 1, totalY + 2);
      doc.text(
        formatCurrency(totalDeductions),
        currentX + gridWidth - 1,
        totalY + 2,
        { align: "right" },
      );

      // Net Pay section
      const netPayY = totalY + totalSectionHeight;
      doc.rect(currentX, netPayY, gridWidth, 4);
      doc.setFontSize(5);
      doc.text("NET PAY:", currentX + 1, netPayY + 2.5);
      doc.text(
        formatCurrency(netPay),
        currentX + gridWidth - 1,
        netPayY + 2.5,
        { align: "right" },
      );

      // Amount in words section - with border to keep it contained
      const wordsY = netPayY + 4;
      doc.rect(currentX, wordsY, gridWidth, 4);
      doc.setFont("helvetica", "italic");
      doc.setFontSize(4);
      const payInWords =
        netPayInWords.length > 65
          ? netPayInWords.substring(0, 65) + "..."
          : netPayInWords;
      doc.text(
        `Amount in words: ${payInWords} only`,
        currentX + 1,
        wordsY + 2.5,
      );

      // Signature section - single line for Authorized Signature only
      const signatureY = wordsY + 4;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(4);
      doc.text("Secretary", currentX + gridWidth / 2, signatureY + 3, {
        align: "center",
      });

      // Count the slip and move to next position
      slipCount++;

      // Track the height of current payslip
      if (slipCount % 2 === 1) {
        // Left column
        leftColumnHeight = gridHeight;
        currentX += gridWidth + margin; // Move to right column
      } else {
        // Right column
        rightColumnHeight = gridHeight;

        // Move to next row - use the maximum height of both columns
        const maxRowHeight = Math.max(leftColumnHeight, rightColumnHeight);
        currentX = margin; // Back to left column
        currentY += maxRowHeight + gapBetweenSlips; // Add gap between rows

        // Reset heights for next row
        leftColumnHeight = 0;
        rightColumnHeight = 0;
      }

      // Check if we're at the end and have an odd number (incomplete row)
      if (index === filterdPayrollData.length - 1 && slipCount % 2 === 1) {
        // Reset position for potential next page
        currentX = margin;
        currentY += leftColumnHeight + gapBetweenSlips;
      }
    });

    // Download the PDF
    doc.save(`All_Employee_Payslips_${monthNameAndYear}.pdf`);
  };

  const generatePayrollReportpdf = (
    selectedColumnsData,
    filterMethod,
    filterdoption,
    companyDetails,
    UserName,
    filterdPayrollData,
  ) => {
    if (!selectedPayrollColumns || selectedPayrollColumns.length === 0) {
      toast.error("Please select at least one column");
      return;
    }

    let { selectedHeaders = [], transformedPayrollData = [] } =
      selectedColumnsData;

    // === FILTERING: If filteredData is provided, show only employees matching EmpId ===
    if (
      filterdPayrollData &&
      Array.isArray(filterdPayrollData) &&
      filterdPayrollData.length > 0
    ) {
      const filteredEmpIds = new Set(
        filterdPayrollData.map((emp) => emp.EmpId).filter(Boolean),
      );
      transformedPayrollData = transformedPayrollData.filter(
        (emp) => emp.EmpId && filteredEmpIds.has(emp.EmpId),
      );

      if (transformedPayrollData.length === 0) {
        alert("No employees match the selected filter.");
        return;
      }
    }

    if (transformedPayrollData.length === 0) {
      alert("No payroll data to generate report");
      return;
    }

    const MethodName = (() => {
      switch (filterMethod) {
        case "ProfitCenterID":
          return "Profitcenter";
        case "DepartmentID":
          return "Department";
        case "GroupId":
          return "Group";
        case "DesignationId":
          return "Designation";
        case "CategoryId":
          return "Category";
        default:
          return null;
      }
    })();

    const fromDate = new Date(transformedPayrollData[0].StartDate);
    const monthNameAndYear = new Intl.DateTimeFormat("en-US", {
      month: "long",
      year: "numeric",
    }).format(fromDate);

    // ✅ KEEP A2 SIZE FOR MAXIMUM SPACE
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a2",
    });

    const formatValue = (val) => {
      if (val === null || val === undefined || val === "") return "";
      const num = parseFloat(val);
      return isNaN(num) || num === 0 ? "" : Math.round(num).toString();
    };

    const formatCurrency = (val) => {
      if (val === null || val === undefined || val === "") return "";
      const num = parseFloat(val);
      return isNaN(num) || num === 0 ? "" : Math.round(num).toFixed(2);
    };

    const getAmountByHeaderName = (emp, headerName, isEarning) => {
      let total = 0;
      const upperHeader = headerName.toString().trim().toUpperCase();
      const components = isEarning ? emp.Additions || [] : emp.Deductions || [];
      components.forEach((comp) => {
        const compName = (comp.ColumnHeaderName || "")
          .toString()
          .trim()
          .toUpperCase();
        if (compName === upperHeader) {
          total += parseFloat(comp.CalculatedAmount) || 0;
        }
      });
      return total;
    };

    // Classify selected headers
    const earningsHeaders = [];
    const deductionsHeaders = [];

    selectedHeaders.forEach((header) => {
      const normalized = header.toString().trim().toUpperCase();
      const isEarning = transformedPayrollData.some((emp) =>
        (emp.Additions || []).some(
          (comp) =>
            (comp.ColumnHeaderName || "").toString().trim().toUpperCase() ===
            normalized,
        ),
      );
      if (isEarning) earningsHeaders.push(header);
      else {
        const isDeduction = transformedPayrollData.some((emp) =>
          (emp.Deductions || []).some(
            (comp) =>
              (comp.ColumnHeaderName || "").toString().trim().toUpperCase() ===
              normalized,
          ),
        );
        if (isDeduction) deductionsHeaders.push(header);
      }
    });

    const fixedStart = ["SL NO", "CODE", "NAME DESIGNATION", "ACTUAL PAY"];
    const fixedEnd = ["TOTAL EARNINGS", "TOTAL DEDN", "NET AMT"];

    const keyColumns = [
      "ACTUAL PAY",
      "TOTAL EARNINGS",
      "TOTAL DEDN",
      "NET AMT",
    ];

    const dynamicHeaders = [
      ...fixedStart,
      ...earningsHeaders,
      ...fixedEnd.slice(0, 1),
      ...deductionsHeaders,
      ...fixedEnd.slice(1),
    ];

    const tableHeaders = [dynamicHeaders];

    const groupedByDepartment = transformedPayrollData.reduce((acc, emp) => {
      const key = emp.ProfitCenterName || "Unknown";
      if (!acc[key]) acc[key] = [];
      acc[key].push(emp);
      return acc;
    }, {});

    function addPageHeader(doc, pageNo, totalPages, deptName = "") {
      const pageWidth = doc.internal.pageSize.width;
      const rightMargin = 15;
      const centerX = pageWidth / 2;

      // ---- Company Name ----
      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.text(companyDetails?.Name?.toUpperCase() || "", centerX, 12, {
        align: "center",
      });

      // ---- Report Title ----
      doc.setFontSize(16);
      doc.text(`DETAILED PAYROLL REPORT FOR ${monthNameAndYear}`, centerX, 20, {
        align: "center",
      });

      // ---- Method / Filter ----
      if (MethodName && filterdoption) {
        doc.setFontSize(11);
        doc.text(`${MethodName.toUpperCase()}: ${filterdoption}`, centerX, 27, {
          align: "center",
        });
      }

      // ---- Department Name ----
      if (deptName) {
        doc.setFontSize(16);
        doc.text(deptName.toUpperCase(), centerX, 34, { align: "center" });
      }

      // ---- Print Date & Time ----
      doc.setFontSize(14);
      const now = new Date();
      const dateStr = now.toLocaleDateString("en-GB");
      const timeStr = now.toLocaleTimeString("en-GB");

      doc.text(`PRINT DATE & TIME: ${dateStr} ${timeStr}`, 15, 40);

      // ---- Page Number (RIGHT ALIGNED – FIXED OVERFLOW) ----
      doc.text(`Page ${pageNo} of ${totalPages}`, pageWidth - rightMargin, 40, {
        align: "right",
      });
    }

    function addPageFooter(doc, y) {
      doc.setFontSize(15); // Increased for better visibility
      const pageWidth = doc.internal.pageSize.width;
      const margin = 40; // Left and right margins
      const availableWidth = pageWidth - 2 * margin;
      const numTitles = 7;
      const spacing = availableWidth / (numTitles - 1);

      // Calculate evenly spaced positions across the page
      const positions = [];
      for (let i = 0; i < numTitles; i++) {
        positions.push(margin + spacing * i);
      }

      const titles = [
        "CLERK",
        "JUNIOR SUPERINTENDENT",
        "ACCOUNTS OFFICER",
        "SUPERINTENDENT",
        "PRESIDENT",
        "SECRETARY",
        "Treasurer",
      ];
      positions.forEach((x, i) => {
        doc.text(titles[i], x, y, { align: "center" });
      });
    }

    // Totals
    const grandTotals = {};
    dynamicHeaders.forEach((h) => {
      if (!["SL NO", "CODE", "NAME DESIGNATION"].includes(h)) {
        grandTotals[h] = 0;
      }
    });

    let totalPages = 0;
    Object.values(groupedByDepartment).forEach((dept) => {
      totalPages += Math.ceil(dept.length / 15); // 15 items per page
    });

    let currentPage = 1;
    let slNo = 1;

    Object.keys(groupedByDepartment).forEach((deptName, deptIndex) => {
      const employees = groupedByDepartment[deptName];
      const isLastDept =
        deptIndex === Object.keys(groupedByDepartment).length - 1;

      const deptTotals = {};
      dynamicHeaders.forEach((h) => {
        if (!["SL NO", "CODE", "NAME DESIGNATION"].includes(h)) {
          deptTotals[h] = 0;
        }
      });

      const rows = employees.map((emp) => {
        const nameDesignation = `${emp.Name || ""}\n${
          emp.DesignationName || ""
        }\n${
          emp.StartingSalary && emp.EndingSalary
            ? `Scale(${emp.StartingSalary}--${emp.EndingSalary})`
            : ""
        }`;

        const actualPay = Math.round(parseFloat(emp.CurrentBasicPay || 0));

        const row = [
          slNo++,
          emp.Code || "",
          nameDesignation,
          formatValue(actualPay),
        ];

        deptTotals["ACTUAL PAY"] += actualPay;
        grandTotals["ACTUAL PAY"] += actualPay;

        let totalEarnings = 0;
        earningsHeaders.forEach((header) => {
          const amount = Math.round(getAmountByHeaderName(emp, header, true));
          row.push(formatValue(amount));
          totalEarnings += amount;
          deptTotals[header] += amount;
          grandTotals[header] += amount;
        });

        row.push(formatCurrency(totalEarnings));
        deptTotals["TOTAL EARNINGS"] += totalEarnings;
        grandTotals["TOTAL EARNINGS"] += totalEarnings;

        let totalDeductions = 0;
        deductionsHeaders.forEach((header) => {
          const amount = Math.round(getAmountByHeaderName(emp, header, false));
          row.push(formatValue(amount));
          totalDeductions += amount;
          deptTotals[header] += amount;
          grandTotals[header] += amount;
        });

        row.push(formatCurrency(totalDeductions));
        deptTotals["TOTAL DEDN"] += totalDeductions;
        grandTotals["TOTAL DEDN"] += totalDeductions;

        const netSalary = totalEarnings - totalDeductions;
        row.push(formatCurrency(netSalary));
        deptTotals["NET AMT"] += netSalary;
        grandTotals["NET AMT"] += netSalary;

        return row;
      });

      const rowsPerPage = 14; // 15 items per page
      for (let i = 0; i < rows.length; i += rowsPerPage) {
        const chunk = rows.slice(i, i + rowsPerPage);
        const isLastChunk = i + rowsPerPage >= rows.length;

        if (currentPage > 1 || i > 0) doc.addPage();

        addPageHeader(doc, currentPage, totalPages, deptName);

        let body = [...chunk];

        if (isLastChunk) {
          const deptTotalRow = [
            {
              content: `Profitcenter Total: ${deptName}`,
              colSpan: 3,
              styles: { fontStyle: "bold", halign: "left", valign: "middle" },
            },
            {
              content: formatValue(deptTotals["ACTUAL PAY"]),
              styles: { fontStyle: "bold", halign: "right", valign: "middle" },
            },
          ];
          [
            ...earningsHeaders,
            "TOTAL EARNINGS",
            ...deductionsHeaders,
            "TOTAL DEDN",
            "NET AMT",
          ].forEach((header) => {
            deptTotalRow.push({
              content: formatCurrency(deptTotals[header]),
              styles: { fontStyle: "bold", halign: "right", valign: "middle" },
            });
          });
          body.push(deptTotalRow);

          if (isLastDept) {
            const grandTotalRow = [
              {
                content: "Grand Total",
                colSpan: 3,
                styles: { fontStyle: "bold", halign: "left", valign: "middle" },
              },
              {
                content: formatValue(grandTotals["ACTUAL PAY"]),
                styles: {
                  fontStyle: "bold",
                  halign: "right",
                  valign: "middle",
                },
              },
            ];
            [
              ...earningsHeaders,
              "TOTAL EARNINGS",
              ...deductionsHeaders,
              "TOTAL DEDN",
              "NET AMT",
            ].forEach((header) => {
              grandTotalRow.push({
                content: formatCurrency(grandTotals[header]),
                styles: {
                  fontStyle: "bold",
                  halign: "right",
                  valign: "middle",
                },
              });
            });
            body.push(grandTotalRow);
          }
        }

        // ✅ OPTIMIZED COLUMN WIDTHS - BETTER SPACE UTILIZATION
        const totalCols = dynamicHeaders.length;
        const pageWidth = doc.internal.pageSize.width;
        const pageHeight = doc.internal.pageSize.height;
        const margin = 8; // Reduced margins from 10 to 8
        const availableWidth = pageWidth - 2 * margin;

        // ✅ INCREASED BASE WIDTHS for better readability
        const baseWidths = {
          slNo: 18, // Increased from 15
          code: 20, // Increased from 15
          nameDesignation: 70, // Increased from 55
          keyColumn: 38, // Increased from 30
          regularColumn: 28, // Increased from 22
        };

        // ✅ INCREASED FONT SIZES
        let baseFontSize = 14; // Increased from 9
        if (totalCols > 20)
          baseFontSize = 13; // Increased from 8
        else if (totalCols > 16)
          baseFontSize = 13.5; // Increased from 8.5
        else if (totalCols > 12)
          baseFontSize = 14; // Increased from 9
        else if (totalCols > 8) baseFontSize = 14.5; // Increased from 9.5

        const headFontSize = 12; // Increased from 8

        // Calculate individual column widths
        const columnWidths = [];
        dynamicHeaders.forEach((header, index) => {
          if (index === 0) {
            // SL NO
            columnWidths.push(baseWidths.slNo);
          } else if (index === 1) {
            // CODE
            columnWidths.push(baseWidths.code);
          } else if (index === 2) {
            // NAME DESIGNATION
            columnWidths.push(baseWidths.nameDesignation);
          } else if (keyColumns.includes(header)) {
            // Key columns
            columnWidths.push(baseWidths.keyColumn);
          } else {
            // Regular columns
            columnWidths.push(baseWidths.regularColumn);
          }
        });

        // Scale to fit available width
        const totalWidthNeeded = columnWidths.reduce(
          (sum, width) => sum + width,
          0,
        );
        const scaleFactor = availableWidth / totalWidthNeeded;

        columnWidths.forEach((width, index) => {
          columnWidths[index] = width * scaleFactor;
        });

        // Create columnStyles with calculated widths
        const columnStyles = {};
        dynamicHeaders.forEach((header, index) => {
          let halign = "left";
          if (index === 0 || index === 1) halign = "center";

          let fontSize = baseFontSize;
          if (index === 2) fontSize = baseFontSize - 0.5; // Slightly smaller for NAME
          if (keyColumns.includes(header)) {
            fontSize = baseFontSize + 0.5; // Slightly larger for key columns
            halign = "right"; // Right-align amount columns
          }

          columnStyles[index] = {
            cellWidth: columnWidths[index],
            halign: halign,
            valign: "middle",
            fontSize: fontSize,
          };
        });

        doc.autoTable({
          head: tableHeaders,
          body: body,
          startY: 45,
          theme: "grid",
          styles: {
            fontSize: baseFontSize,
            cellPadding: 2.5, // Increased from 1.5
            valign: "middle",
            halign: "left",
            textColor: [0, 0, 0],
            lineColor: [0, 0, 0],
            lineWidth: 0.3,
            minCellHeight: 12, // ✅ Increased minimum cell height for better vertical spacing
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            fontStyle: "bold",
            fontSize: headFontSize,
            halign: "center",
            valign: "middle",
            lineWidth: 0.3,
            lineColor: [0, 0, 0],
            minCellHeight: 10, // ✅ Header height
          },
          columnStyles: columnStyles,
          margin: { top: 45, left: margin, right: margin, bottom: 40 },
          tableWidth: "auto",
          didParseCell: (data) => {
            if (
              ["TOTAL EARNINGS", "TOTAL DEDN", "NET AMT"].includes(
                dynamicHeaders[data.column.index],
              )
            ) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.halign = "right";
            }
          },
          didDrawPage: (data) => {
            // ✅ Ensure table uses full vertical space
            const finalY = data.cursor.y;
            const remainingSpace = pageHeight - finalY - 40;

            // If there's significant remaining space and we have rows, adjust spacing
            if (remainingSpace > 50 && body.length > 0) {
              const extraPadding = Math.min(
                3,
                remainingSpace / body.length / 2,
              );
              // This will be applied in next iteration if needed
            }
          },
        });

        const finalY = doc.lastAutoTable.finalY;

        if (isLastDept && isLastChunk) {
          // ✅ Add "Generated on/by" immediately after table
          doc.setFontSize(12); // Increased from 9 for better visibility
          const today = new Date().toLocaleDateString("en-GB");
          doc.text(`Generated on: ${today}`, pageWidth - margin, finalY + 10, {
            align: "right",
          });
          doc.text(
            `Generated by: ${UserName || "User"}`,
            pageWidth - margin,
            finalY + 16,
            { align: "right" },
          );

          // ✅ Add signature section immediately after "Generated on/by"
          addPageFooter(doc, finalY + 30);
        }

        currentPage++;
      }
    });

    doc.save(`Payroll_Detailed_Report_${monthNameAndYear}.pdf`);
  };

  const generateMonthlyConsoldatedEmployee = (
    EmployeeId,
    employeeData,
    componentData,
    filterMethod,
    filterdoption,
  ) => {
    if (!selectedPayrollColumns || selectedPayrollColumns.length === 0) {
      toast.error("Please select at least one column");
      return;
    }

    // Data is already parsed
    const transformedData = employeeData;

    // Filter for the specific employee
    const filteredEmployeeData = transformedData.filter(
      (emp) => emp.EmpId === EmployeeId,
    );

    // Sort chronologically
    const uniqueEmployeeData = filteredEmployeeData.sort(
      (a, b) => new Date(a.StartDate) - new Date(b.StartDate),
    );

    if (uniqueEmployeeData.length === 0) {
      toast.error("No employee data found for the specified employee");
      return;
    }

    const fromDate = new Date(uniqueEmployeeData[0].StartDate);
    if (isNaN(fromDate.getTime())) {
      toast.error("Invalid date");
      return;
    }

    // Use A2 landscape — consistent with other reports
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a2",
    });

    doc.setProperties({
      title: "Payroll Detailed Report",
      subject: "Monthly Payroll Report",
      author: "Payroll System",
    });

    const formatValue = (val) => {
      if (val === null || val === undefined || val === "") return "";
      const num = parseFloat(val);
      return isNaN(num) || num === 0 ? "" : Math.round(num).toString();
    };

    const formatCurrency = (val) => {
      if (val === null || val === undefined || val === "") return "";
      const num = parseFloat(val);
      return isNaN(num) || num === 0 ? "" : Math.round(num).toFixed(2);
    };

    const getAmountByHeaderName = (emp, headerName, isEarning) => {
      let total = 0;
      const upperHeader = headerName.toString().trim().toUpperCase();
      const components = isEarning ? emp.Additions || [] : emp.Deductions || [];
      components.forEach((comp) => {
        const compName = (comp.ColumnHeaderName || "")
          .toString()
          .trim()
          .toUpperCase();
        if (compName === upperHeader) {
          total += parseFloat(comp.CalculatedAmount) || 0;
        }
      });
      return total;
    };

    // Classify selected headers
    const earningsHeaders = [];
    const deductionsHeaders = [];

    selectedPayrollColumns.forEach((header) => {
      const normalized = header.toString().trim().toUpperCase();
      const isEarning = transformedData.some((emp) =>
        (emp.Additions || []).some(
          (comp) =>
            (comp.ColumnHeaderName || "").toString().trim().toUpperCase() ===
            normalized,
        ),
      );
      if (isEarning) earningsHeaders.push(header);
      else {
        const isDeduction = transformedData.some((emp) =>
          (emp.Deductions || []).some(
            (comp) =>
              (comp.ColumnHeaderName || "").toString().trim().toUpperCase() ===
              normalized,
          ),
        );
        if (isDeduction) deductionsHeaders.push(header);
      }
    });

    const fixedStart = ["SL NO", "MONTH & YEAR", "ACTUAL PAY"];
    const fixedEnd = ["TOTAL EARNINGS", "TOTAL DEDN", "NET AMT"];

    const dynamicHeaders = [
      ...fixedStart,
      ...earningsHeaders,
      ...fixedEnd.slice(0, 1),
      ...deductionsHeaders,
      ...fixedEnd.slice(1),
    ];

    const tableHeaders = [dynamicHeaders];

    function getMonthName(monthNumber) {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return months[monthNumber - 1] || "";
    }

    const formatDate = (isoString) => {
      if (!isoString) return "";
      const date = new Date(isoString);
      if (isNaN(date.getTime())) return "";
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    // ── Consistent & cleaner header ──
    function addPageHeader(doc, pageNumber, totalPages) {
      const pageWidth = doc.internal.pageSize.width;
      const centerX = pageWidth / 2;
      const rightMargin = 15;

      // Company Name
      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.text(companyDetails?.Name?.toUpperCase() || "", centerX, 12, {
        align: "center",
      });

      // Report Title
      doc.setFontSize(16);
      doc.text("PAY BILL REGISTER", centerX, 20, { align: "center" });

      const emp = uniqueEmployeeData[0];

      // Employee Details – two columns
      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");

      const leftX = 15;
      const rightX = pageWidth / 2 + 20;
      let yPos = 32;

      // Left column
      doc.text("Name:", leftX, yPos);
      doc.text(emp.Name || "", leftX + 35, yPos);
      yPos += 7;

      doc.text("Code:", leftX, yPos);
      doc.text(emp.Code || "", leftX + 35, yPos);
      yPos += 7;

      doc.text("Designation:", leftX, yPos);
      doc.text(emp.DesignationName || "", leftX + 35, yPos);
      yPos += 7;

      doc.text("Scale of Pay:", leftX, yPos);
      doc.text(
        `${emp.StartingSalary || ""} - ${emp.EndingSalary || ""}`,
        leftX + 35,
        yPos,
      );
      yPos += 7;

      doc.text("Pay:", leftX, yPos);
      doc.text(formatValue(emp.CurrentBasicPay || ""), leftX + 35, yPos);
      yPos += 7;

      doc.text("Bank:", leftX, yPos);
      doc.text(emp.BankName || "", leftX + 35, yPos);
      yPos += 7;

      doc.text("A/c No:", leftX, yPos);
      doc.text(emp.AccNo || "", leftX + 35, yPos);

      // Right column
      yPos = 32;
      doc.text("PF No.:", rightX, yPos);
      doc.text(emp.PFNo || "", rightX + 35, yPos);
      yPos += 7;

      doc.text("LIC No.:", rightX, yPos);
      doc.text(emp.LicNumber || "", rightX + 35, yPos);
      yPos += 7;

      doc.text("PAN:", rightX, yPos);
      doc.text(emp.PAN || "", rightX + 35, yPos);
      yPos += 7;

      doc.text("Aadhaar:", rightX, yPos);
      doc.text(emp.AadharNo || "", rightX + 35, yPos);
      yPos += 7;

      doc.text("Next Increment:", rightX, yPos);
      doc.text(formatDate(emp.IncrementDate), rightX + 35, yPos);

      // Print Date & Time + Page
      doc.setFontSize(14);
      const now = new Date();
      const dateStr = now.toLocaleDateString("en-GB");
      const timeStr = now.toLocaleTimeString("en-GB");
      doc.text(`PRINT DATE & TIME: ${dateStr} ${timeStr}`, 15, 70);

      doc.text(
        `Page ${pageNumber} of ${totalPages}`,
        pageWidth - rightMargin,
        70,
        { align: "right" },
      );
    }

    // ── Footer ── same as others
    function addPageFooter(doc, y) {
      doc.setFontSize(15);
      const pageWidth = doc.internal.pageSize.width;
      const margin = 40;
      const availableWidth = pageWidth - 2 * margin;
      const numTitles = 7;
      const spacing = availableWidth / (numTitles - 1);

      const positions = [];
      for (let i = 0; i < numTitles; i++) {
        positions.push(margin + spacing * i);
      }

      const titles = [
        "CLERK",
        "JUNIOR SUPERINTENDENT",
        "ACCOUNTS OFFICER",
        "SUPERINTENDENT",
        "PRESIDENT",
        "SECRETARY",
        "Treasurer",
      ];

      positions.forEach((x, i) => {
        doc.text(titles[i], x, y, { align: "center" });
      });
    }

    // Grand Totals
    const grandTotals = {};
    dynamicHeaders.forEach((h) => {
      if (!["SL NO", "MONTH & YEAR"].includes(h)) {
        grandTotals[h] = 0;
      }
    });

    const rowsPerPage = 15;
    const totalPages = Math.ceil(uniqueEmployeeData.length / rowsPerPage) || 1;

    let currentPage = 1;

    const tableData = uniqueEmployeeData.map((emp, index) => {
      const monthName = getMonthName(emp.PayrollMonth);
      const monthYear = `${monthName} ${emp.PayrollYear}`;

      const actualPay = Math.round(parseFloat(emp.CurrentBasicPay || 0));
      const row = [index + 1, monthYear, formatValue(actualPay)];

      grandTotals["ACTUAL PAY"] = (grandTotals["ACTUAL PAY"] || 0) + actualPay;

      let totalEarnings = 0;
      earningsHeaders.forEach((header) => {
        const amount = Math.round(getAmountByHeaderName(emp, header, true));
        row.push(formatValue(amount));
        totalEarnings += amount;
        grandTotals[header] = (grandTotals[header] || 0) + amount;
      });

      row.push(formatCurrency(totalEarnings));
      grandTotals["TOTAL EARNINGS"] =
        (grandTotals["TOTAL EARNINGS"] || 0) + totalEarnings;

      let totalDeductions = 0;
      deductionsHeaders.forEach((header) => {
        const amount = Math.round(getAmountByHeaderName(emp, header, false));
        row.push(formatValue(amount));
        totalDeductions += amount;
        grandTotals[header] = (grandTotals[header] || 0) + amount;
      });

      const netSalary = totalEarnings - totalDeductions;
      row.push(formatCurrency(totalDeductions));
      row.push(formatCurrency(netSalary));

      grandTotals["TOTAL DEDN"] =
        (grandTotals["TOTAL DEDN"] || 0) + totalDeductions;
      grandTotals["NET AMT"] = (grandTotals["NET AMT"] || 0) + netSalary;

      return row;
    });

    // Split into pages
    const chunks = [];
    for (let i = 0; i < tableData.length; i += rowsPerPage) {
      chunks.push(tableData.slice(i, i + rowsPerPage));
    }

    chunks.forEach((chunk, chunkIndex) => {
      if (currentPage > 1 || chunkIndex > 0) doc.addPage();

      addPageHeader(doc, currentPage, totalPages);

      let bodyData = [...chunk];

      if (chunkIndex === chunks.length - 1) {
        const grandTotalRow = [
          {
            content: "Grand Total",
            colSpan: 2,
            styles: { fontStyle: "bold", halign: "left", valign: "middle" },
          },
          {
            content: formatValue(grandTotals["ACTUAL PAY"]),
            styles: { fontStyle: "bold", halign: "right", valign: "middle" },
          },
        ];

        [
          ...earningsHeaders,
          "TOTAL EARNINGS",
          ...deductionsHeaders,
          "TOTAL DEDN",
          "NET AMT",
        ].forEach((header) => {
          grandTotalRow.push({
            content: formatCurrency(grandTotals[header]),
            styles: { fontStyle: "bold", halign: "right", valign: "middle" },
          });
        });

        bodyData.push(grandTotalRow);
      }

      // ── Column width & font logic ── (same as other reports)
      const totalCols = dynamicHeaders.length;
      const pageWidth = doc.internal.pageSize.width;
      const margin = 8;
      const availableWidth = pageWidth - 2 * margin;

      const baseWidths = {
        slNo: 18,
        monthYear: 55, // adjusted for "MONTH & YEAR"
        keyColumn: 38,
        regularColumn: 28,
      };

      let baseFontSize = 14;
      if (totalCols > 20) baseFontSize = 13;
      else if (totalCols > 16) baseFontSize = 13.5;
      else if (totalCols > 12) baseFontSize = 14;
      else if (totalCols > 8) baseFontSize = 14.5;

      const headFontSize = 12;

      const columnWidths = [];
      dynamicHeaders.forEach((header, index) => {
        if (index === 0) columnWidths.push(baseWidths.slNo);
        else if (index === 1) columnWidths.push(baseWidths.monthYear);
        else if (
          ["ACTUAL PAY", "TOTAL EARNINGS", "TOTAL DEDN", "NET AMT"].includes(
            header,
          )
        )
          columnWidths.push(baseWidths.keyColumn);
        else columnWidths.push(baseWidths.regularColumn);
      });

      const totalWidthNeeded = columnWidths.reduce((sum, w) => sum + w, 0);
      const scaleFactor = availableWidth / totalWidthNeeded;
      columnWidths.forEach((w, i) => {
        columnWidths[i] = w * scaleFactor;
      });

      const columnStyles = {};
      dynamicHeaders.forEach((header, index) => {
        let halign = index === 1 ? "center" : "right";
        if (index === 0) halign = "center";

        let fontSize = baseFontSize;
        if (index === 1) fontSize = baseFontSize - 0.5;

        columnStyles[index] = {
          cellWidth: columnWidths[index],
          halign,
          valign: "middle",
          fontSize,
        };
      });

      doc.autoTable({
        head: tableHeaders,
        body: bodyData,
        startY: 80, // Adjusted for taller header
        theme: "grid",
        styles: {
          fontSize: baseFontSize,
          cellPadding: 2.5,
          valign: "middle",
          lineColor: [0, 0, 0],
          lineWidth: 0.3,
          minCellHeight: 12,
        },
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          fontStyle: "bold",
          fontSize: headFontSize,
          halign: "center",
          valign: "middle",
          lineWidth: 0.3,
          lineColor: [0, 0, 0],
          minCellHeight: 10,
        },
        columnStyles,
        margin: { top: 80, left: margin, right: margin, bottom: 40 },
        tableWidth: "auto",
        didParseCell: (data) => {
          if (
            ["TOTAL EARNINGS", "TOTAL DEDN", "NET AMT"].includes(
              dynamicHeaders[data.column.index],
            )
          ) {
            data.cell.styles.fontStyle = "bold";
            data.cell.styles.halign = "right";
          }
        },
      });

      const finalY = doc.lastAutoTable.finalY;

      if (chunkIndex === chunks.length - 1) {
        doc.setFontSize(12);
        const today = new Date().toLocaleDateString("en-GB");
        doc.text(`Generated on: ${today}`, pageWidth - margin, finalY + 10, {
          align: "right",
        });
        doc.text(
          `Generated by: ${UserName || "User"}`,
          pageWidth - margin,
          finalY + 16,
          { align: "right" },
        );
      }

      addPageFooter(doc, finalY + 30);
      currentPage++;
    });

    const employeeName = uniqueEmployeeData[0].Name || "Employee";
    const monthYear = new Date(uniqueEmployeeData[0].StartDate).toLocaleString(
      "en-US",
      {
        month: "long",
        year: "numeric",
      },
    );

    doc.save(`Pay_Bill_Register_${employeeName}_${monthYear}.pdf`);
  };

  const generatePayrollReportDeppdf = (
    selectedColumnsData,
    filterMethod,
    filterdoption,
    companyDetails,
    UserName,
    filterdPayrollData,
  ) => {
    if (!selectedPayrollColumns || selectedPayrollColumns.length === 0) {
      toast.error("Please select at least one column");
      return;
    }

    let { selectedHeaders = [], transformedPayrollData = [] } =
      selectedColumnsData;

    // Filtering logic (same as before)
    if (
      filterdPayrollData &&
      Array.isArray(filterdPayrollData) &&
      filterdPayrollData.length > 0
    ) {
      const filteredEmpIds = new Set(
        filterdPayrollData.map((emp) => emp.EmpId).filter(Boolean),
      );
      transformedPayrollData = transformedPayrollData.filter(
        (emp) => emp.EmpId && filteredEmpIds.has(emp.EmpId),
      );

      if (transformedPayrollData.length === 0) {
        alert("No employees match the selected filter.");
        return;
      }
    }

    if (transformedPayrollData.length === 0) {
      alert("No payroll data to generate report");
      return;
    }

    const MethodName = (() => {
      switch (filterMethod) {
        case "ProfitCenterID":
          return "Profitcenter";
        case "DepartmentID":
          return "Department";
        case "GroupId":
          return "Group";
        case "DesignationId":
          return "Designation";
        case "CategoryId":
          return "Category";
        default:
          return null;
      }
    })();

    const fromDate = new Date(transformedPayrollData[0].StartDate);
    const monthNameAndYear = new Intl.DateTimeFormat("en-US", {
      month: "long",
      year: "numeric",
    }).format(fromDate);

    // ── Use A2 landscape like the detailed report ──
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a2",
    });

    const formatValue = (val) => {
      if (val === null || val === undefined || val === "") return "";
      const num = parseFloat(val);
      return isNaN(num) || num === 0 ? "" : Math.round(num).toString();
    };

    const formatCurrency = (val) => {
      if (val === null || val === undefined || val === "") return "";
      const num = parseFloat(val);
      return isNaN(num) || num === 0 ? "" : Math.round(num).toFixed(2);
    };

    const getAmountByHeaderName = (emp, headerName, isEarning) => {
      let total = 0;
      const upperHeader = headerName.toString().trim().toUpperCase();
      const components = isEarning ? emp.Additions || [] : emp.Deductions || [];
      components.forEach((comp) => {
        const compName = (comp.ColumnHeaderName || "")
          .toString()
          .trim()
          .toUpperCase();
        if (compName === upperHeader) {
          total += parseFloat(comp.CalculatedAmount) || 0;
        }
      });
      return total;
    };

    // Classify headers
    const earningsHeaders = [];
    const deductionsHeaders = [];

    selectedHeaders.forEach((header) => {
      const normalized = header.toString().trim().toUpperCase();
      const isEarning = transformedPayrollData.some((emp) =>
        (emp.Additions || []).some(
          (comp) =>
            (comp.ColumnHeaderName || "").toString().trim().toUpperCase() ===
            normalized,
        ),
      );
      if (isEarning) earningsHeaders.push(header);
      else {
        const isDeduction = transformedPayrollData.some((emp) =>
          (emp.Deductions || []).some(
            (comp) =>
              (comp.ColumnHeaderName || "").toString().trim().toUpperCase() ===
              normalized,
          ),
        );
        if (isDeduction) deductionsHeaders.push(header);
      }
    });

    const fixedStart = ["SL NO", "DEPARTMENT", "ACTUAL PAY"];
    const fixedEnd = ["TOTAL EARNINGS", "TOTAL DEDN", "NET AMT"];

    const dynamicHeaders = [
      ...fixedStart,
      ...earningsHeaders,
      ...fixedEnd.slice(0, 1),
      ...deductionsHeaders,
      ...fixedEnd.slice(1),
    ];

    const tableHeaders = [dynamicHeaders];

    // Group data
    const groupedByDepartment = transformedPayrollData.reduce((acc, emp) => {
      const key = emp.DepartmentName || "Unknown";
      if (!acc[key]) acc[key] = [];
      acc[key].push(emp);
      return acc;
    }, {});

    // ── Header ── (aligned with detailed report style)
    function addPageHeader(doc, pageNo, totalPages) {
      const pageWidth = doc.internal.pageSize.width;
      const centerX = pageWidth / 2;
      const rightMargin = 15;

      // Company Name
      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.text(companyDetails?.Name?.toUpperCase() || "", centerX, 12, {
        align: "center",
      });

      // Report Title
      doc.setFontSize(16);
      doc.text(
        `DEPARTMENT TOTALS PAYROLL REPORT FOR ${monthNameAndYear}`,
        centerX,
        20,
        { align: "center" },
      );

      // Method / Filter
      if (MethodName && filterdoption) {
        doc.setFontSize(11);
        doc.text(`${MethodName.toUpperCase()}: ${filterdoption}`, centerX, 27, {
          align: "center",
        });
      }

      // Print Date & Time
      doc.setFontSize(14);
      const now = new Date();
      const dateStr = now.toLocaleDateString("en-GB");
      const timeStr = now.toLocaleTimeString("en-GB");
      doc.text(`PRINT DATE & TIME: ${dateStr} ${timeStr}`, 15, 40);

      // Page Number
      doc.text(`Page ${pageNo} of ${totalPages}`, pageWidth - rightMargin, 40, {
        align: "right",
      });
    }

    // ── Footer ── (same positions & size as detailed report)
    function addPageFooter(doc, y) {
      doc.setFontSize(15);
      const pageWidth = doc.internal.pageSize.width;
      const margin = 40;
      const availableWidth = pageWidth - 2 * margin;
      const numTitles = 7;
      const spacing = availableWidth / (numTitles - 1);

      const positions = [];
      for (let i = 0; i < numTitles; i++) {
        positions.push(margin + spacing * i);
      }

      const titles = [
        "CLERK",
        "JUNIOR SUPERINTENDENT",
        "ACCOUNTS OFFICER",
        "SUPERINTENDENT",
        "PRESIDENT",
        "SECRETARY",
        "Treasurer",
      ];

      positions.forEach((x, i) => {
        doc.text(titles[i], x, y, { align: "center" });
      });
    }

    // Totals
    const grandTotals = {};
    dynamicHeaders.forEach((h) => {
      if (!["SL NO", "DEPARTMENT"].includes(h)) {
        grandTotals[h] = 0;
      }
    });

    // Calculate total pages (very rough – 20–22 rows per page on A2)
    const rowsPerPage = 20;
    const totalDepartments = Object.keys(groupedByDepartment).length;
    const totalPages = Math.ceil(totalDepartments / rowsPerPage) || 1;

    let currentPage = 1;

    addPageHeader(doc, currentPage, totalPages);

    const tableData = Object.keys(groupedByDepartment).map(
      (deptName, index) => {
        const employees = groupedByDepartment[deptName];

        const deptTotals = {};
        dynamicHeaders.forEach((h) => {
          if (!["SL NO", "DEPARTMENT"].includes(h)) deptTotals[h] = 0;
        });

        employees.forEach((emp) => {
          const actualPay = Math.round(parseFloat(emp.CurrentBasicPay || 0));
          deptTotals["ACTUAL PAY"] += actualPay;
          grandTotals["ACTUAL PAY"] += actualPay;

          let totalEarnings = 0;
          earningsHeaders.forEach((header) => {
            const amount = Math.round(getAmountByHeaderName(emp, header, true));
            totalEarnings += amount;
            deptTotals[header] = (deptTotals[header] || 0) + amount;
            grandTotals[header] = (grandTotals[header] || 0) + amount;
          });

          deptTotals["TOTAL EARNINGS"] += totalEarnings;
          grandTotals["TOTAL EARNINGS"] += totalEarnings;

          let totalDeductions = 0;
          deductionsHeaders.forEach((header) => {
            const amount = Math.round(
              getAmountByHeaderName(emp, header, false),
            );
            totalDeductions += amount;
            deptTotals[header] = (deptTotals[header] || 0) + amount;
            grandTotals[header] = (grandTotals[header] || 0) + amount;
          });

          const netSalary = totalEarnings - totalDeductions;
          deptTotals["TOTAL DEDN"] += totalDeductions;
          deptTotals["NET AMT"] += netSalary;
          grandTotals["TOTAL DEDN"] += totalDeductions;
          grandTotals["NET AMT"] += netSalary;
        });

        const row = [
          index + 1,
          deptName,
          formatValue(deptTotals["ACTUAL PAY"]),
        ];

        earningsHeaders.forEach((header) =>
          row.push(formatValue(deptTotals[header])),
        );
        row.push(formatCurrency(deptTotals["TOTAL EARNINGS"]));

        deductionsHeaders.forEach((header) =>
          row.push(formatValue(deptTotals[header])),
        );
        row.push(formatCurrency(deptTotals["TOTAL DEDN"]));
        row.push(formatCurrency(deptTotals["NET AMT"]));

        return row;
      },
    );

    // Grand total row
    const grandTotalRow = [
      {
        content: "Grand Total",
        colSpan: 2,
        styles: { fontStyle: "bold", halign: "left", valign: "middle" },
      },
      {
        content: formatValue(grandTotals["ACTUAL PAY"]),
        styles: { fontStyle: "bold", halign: "right", valign: "middle" },
      },
    ];

    [
      ...earningsHeaders,
      "TOTAL EARNINGS",
      ...deductionsHeaders,
      "TOTAL DEDN",
      "NET AMT",
    ].forEach((header) => {
      grandTotalRow.push({
        content: formatCurrency(grandTotals[header]),
        styles: { fontStyle: "bold", halign: "right", valign: "middle" },
      });
    });

    const body = [...tableData, grandTotalRow];

    // ── Column width & font logic ── (almost identical to detailed report)
    const totalCols = dynamicHeaders.length;
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const margin = 8;
    const availableWidth = pageWidth - 2 * margin;

    const baseWidths = {
      slNo: 18,
      department: 70, // wider than name in detailed report
      keyColumn: 38,
      regularColumn: 28,
    };

    let baseFontSize = 14;
    if (totalCols > 20) baseFontSize = 13;
    else if (totalCols > 16) baseFontSize = 13.5;
    else if (totalCols > 12) baseFontSize = 14;
    else if (totalCols > 8) baseFontSize = 14.5;

    const headFontSize = 12;

    // Calculate column widths
    const columnWidths = [];
    dynamicHeaders.forEach((header, index) => {
      if (index === 0) {
        columnWidths.push(baseWidths.slNo); // SL NO
      } else if (index === 1) {
        columnWidths.push(baseWidths.department); // DEPARTMENT
      } else if (
        ["ACTUAL PAY", "TOTAL EARNINGS", "TOTAL DEDN", "NET AMT"].includes(
          header,
        )
      ) {
        columnWidths.push(baseWidths.keyColumn);
      } else {
        columnWidths.push(baseWidths.regularColumn);
      }
    });

    // Scale to fit page
    const totalWidthNeeded = columnWidths.reduce((sum, w) => sum + w, 0);
    const scaleFactor = availableWidth / totalWidthNeeded;
    columnWidths.forEach((w, i) => {
      columnWidths[i] = w * scaleFactor;
    });

    // Column styles
    const columnStyles = {};
    dynamicHeaders.forEach((header, index) => {
      let halign = index === 1 ? "left" : "right";
      if (index === 0) halign = "center";

      let fontSize = baseFontSize;
      if (index === 1) fontSize = baseFontSize - 0.5; // slightly smaller for department name

      columnStyles[index] = {
        cellWidth: columnWidths[index],
        halign,
        valign: "middle",
        fontSize,
      };
    });

    doc.autoTable({
      head: tableHeaders,
      body,
      startY: 45,
      theme: "grid",
      styles: {
        fontSize: baseFontSize,
        cellPadding: 2.5,
        valign: "middle",
        lineColor: [0, 0, 0],
        lineWidth: 0.3,
        minCellHeight: 12,
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        fontSize: headFontSize,
        halign: "center",
        valign: "middle",
        lineWidth: 0.3,
        lineColor: [0, 0, 0],
        minCellHeight: 10,
      },
      columnStyles,
      margin: { top: 45, left: margin, right: margin, bottom: 40 },
      tableWidth: "auto",
      didParseCell: (data) => {
        if (
          ["TOTAL EARNINGS", "TOTAL DEDN", "NET AMT"].includes(
            dynamicHeaders[data.column.index],
          )
        ) {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.halign = "right";
        }
      },
    });

    const finalY = doc.lastAutoTable.finalY;

    // Generated info (same position/style)
    doc.setFontSize(12);
    const today = new Date().toLocaleDateString("en-GB");
    doc.text(`Generated on: ${today}`, pageWidth - margin, finalY + 10, {
      align: "right",
    });
    doc.text(
      `Generated by: ${UserName || "User"}`,
      pageWidth - margin,
      finalY + 16,
      { align: "right" },
    );

    // Signature block
    addPageFooter(doc, finalY + 30);

    doc.save(`Payroll_Department_Totals_Report_${monthNameAndYear}.pdf`);
  };
  const generatePayrollReportProfitCenterpdf = (
    selectedColumnsData,
    filterMethod,
    filterdoption,
    companyDetails,
    UserName,
    filterdPayrollData,
  ) => {
    if (!selectedPayrollColumns || selectedPayrollColumns.length === 0) {
      toast.error("Please select at least one column");
      return;
    }

    let { selectedHeaders = [], transformedPayrollData = [] } =
      selectedColumnsData;

    // Filtering (same as before)
    if (
      filterdPayrollData &&
      Array.isArray(filterdPayrollData) &&
      filterdPayrollData.length > 0
    ) {
      const filteredEmpIds = new Set(
        filterdPayrollData.map((emp) => emp.EmpId).filter(Boolean),
      );
      transformedPayrollData = transformedPayrollData.filter(
        (emp) => emp.EmpId && filteredEmpIds.has(emp.EmpId),
      );

      if (transformedPayrollData.length === 0) {
        alert("No employees match the selected filter.");
        return;
      }
    }

    if (transformedPayrollData.length === 0) {
      alert("No payroll data to generate report");
      return;
    }

    const MethodName = (() => {
      switch (filterMethod) {
        case "ProfitCenterID":
          return "Profitcenter";
        case "DepartmentID":
          return "Department";
        case "GroupId":
          return "Group";
        case "DesignationId":
          return "Designation";
        case "CategoryId":
          return "Category";
        default:
          return null;
      }
    })();

    const fromDate = new Date(transformedPayrollData[0].StartDate);
    const monthNameAndYear = new Intl.DateTimeFormat("en-US", {
      month: "long",
      year: "numeric",
    }).format(fromDate);

    // Use A2 landscape – consistent with other reports
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a2",
    });

    const formatValue = (val) => {
      if (val === null || val === undefined || val === "") return "";
      const num = parseFloat(val);
      return isNaN(num) || num === 0 ? "" : Math.round(num).toString();
    };

    const formatCurrency = (val) => {
      if (val === null || val === undefined || val === "") return "";
      const num = parseFloat(val);
      return isNaN(num) || num === 0 ? "" : Math.round(num).toFixed(2);
    };

    const getAmountByHeaderName = (emp, headerName, isEarning) => {
      let total = 0;
      const upperHeader = headerName.toString().trim().toUpperCase();
      const components = isEarning ? emp.Additions || [] : emp.Deductions || [];
      components.forEach((comp) => {
        const compName = (comp.ColumnHeaderName || "")
          .toString()
          .trim()
          .toUpperCase();
        if (compName === upperHeader) {
          total += parseFloat(comp.CalculatedAmount) || 0;
        }
      });
      return total;
    };

    // Classify selected headers
    const earningsHeaders = [];
    const deductionsHeaders = [];

    selectedHeaders.forEach((header) => {
      const normalized = header.toString().trim().toUpperCase();
      const isEarning = transformedPayrollData.some((emp) =>
        (emp.Additions || []).some(
          (comp) =>
            (comp.ColumnHeaderName || "").toString().trim().toUpperCase() ===
            normalized,
        ),
      );
      if (isEarning) earningsHeaders.push(header);
      else {
        const isDeduction = transformedPayrollData.some((emp) =>
          (emp.Deductions || []).some(
            (comp) =>
              (comp.ColumnHeaderName || "").toString().trim().toUpperCase() ===
              normalized,
          ),
        );
        if (isDeduction) deductionsHeaders.push(header);
      }
    });

    const fixedStart = ["SL NO", "PROFIT CENTER", "ACTUAL PAY"];
    const fixedEnd = ["TOTAL EARNINGS", "TOTAL DEDN", "NET AMT"];

    const dynamicHeaders = [
      ...fixedStart,
      ...earningsHeaders,
      ...fixedEnd.slice(0, 1),
      ...deductionsHeaders,
      ...fixedEnd.slice(1),
    ];

    const tableHeaders = [dynamicHeaders];

    const groupedByProfitCenter = transformedPayrollData.reduce((acc, emp) => {
      const key = emp.ProfitCenterName || "Unknown";
      if (!acc[key]) acc[key] = [];
      acc[key].push(emp);
      return acc;
    }, {});

    // ── Consistent page header ──
    function addPageHeader(doc, pageNo, totalPages) {
      const pageWidth = doc.internal.pageSize.width;
      const centerX = pageWidth / 2;
      const rightMargin = 15;

      // Company Name
      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.text(companyDetails?.Name?.toUpperCase() || "", centerX, 12, {
        align: "center",
      });

      // Report Title
      doc.setFontSize(16);
      doc.text(
        `PROFIT CENTER TOTALS PAYROLL REPORT FOR ${monthNameAndYear}`,
        centerX,
        20,
        { align: "center" },
      );

      // Method / Filter (if applicable)
      if (MethodName && filterdoption) {
        doc.setFontSize(11);
        doc.text(`${MethodName.toUpperCase()}: ${filterdoption}`, centerX, 27, {
          align: "center",
        });
      }

      // Print Date & Time
      doc.setFontSize(14);
      const now = new Date();
      const dateStr = now.toLocaleDateString("en-GB");
      const timeStr = now.toLocaleTimeString("en-GB");
      doc.text(`PRINT DATE & TIME: ${dateStr} ${timeStr}`, 15, 40);

      // Page Number
      doc.text(`Page ${pageNo} of ${totalPages}`, pageWidth - rightMargin, 40, {
        align: "right",
      });
    }

    // ── Consistent footer ──
    function addPageFooter(doc, y) {
      doc.setFontSize(15);
      const pageWidth = doc.internal.pageSize.width;
      const margin = 40;
      const availableWidth = pageWidth - 2 * margin;
      const numTitles = 7;
      const spacing = availableWidth / (numTitles - 1);

      const positions = [];
      for (let i = 0; i < numTitles; i++) {
        positions.push(margin + spacing * i);
      }

      const titles = [
        "CLERK",
        "JUNIOR SUPERINTENDENT",
        "ACCOUNTS OFFICER",
        "SUPERINTENDENT",
        "PRESIDENT",
        "SECRETARY",
        "Treasurer",
      ];

      positions.forEach((x, i) => {
        doc.text(titles[i], x, y, { align: "center" });
      });
    }

    // Grand Totals
    const grandTotals = {};
    dynamicHeaders.forEach((h) => {
      if (!["SL NO", "PROFIT CENTER"].includes(h)) {
        grandTotals[h] = 0;
      }
    });

    // Rough total pages estimation (A2 can hold ~20–24 rows comfortably)
    const rowsPerPage = 20;
    const totalProfitCenters = Object.keys(groupedByProfitCenter).length;
    const totalPages = Math.ceil(totalProfitCenters / rowsPerPage) || 1;

    let currentPage = 1;

    addPageHeader(doc, currentPage, totalPages);

    const tableData = Object.keys(groupedByProfitCenter).map(
      (profitCenterName, index) => {
        const employees = groupedByProfitCenter[profitCenterName];

        const profitCenterTotals = {};
        dynamicHeaders.forEach((h) => {
          if (!["SL NO", "PROFIT CENTER"].includes(h))
            profitCenterTotals[h] = 0;
        });

        employees.forEach((emp) => {
          const actualPay = Math.round(parseFloat(emp.CurrentBasicPay || 0));
          profitCenterTotals["ACTUAL PAY"] += actualPay;
          grandTotals["ACTUAL PAY"] += actualPay;

          let totalEarnings = 0;
          earningsHeaders.forEach((header) => {
            const amount = Math.round(getAmountByHeaderName(emp, header, true));
            totalEarnings += amount;
            profitCenterTotals[header] =
              (profitCenterTotals[header] || 0) + amount;
            grandTotals[header] = (grandTotals[header] || 0) + amount;
          });

          profitCenterTotals["TOTAL EARNINGS"] += totalEarnings;
          grandTotals["TOTAL EARNINGS"] += totalEarnings;

          let totalDeductions = 0;
          deductionsHeaders.forEach((header) => {
            const amount = Math.round(
              getAmountByHeaderName(emp, header, false),
            );
            totalDeductions += amount;
            profitCenterTotals[header] =
              (profitCenterTotals[header] || 0) + amount;
            grandTotals[header] = (grandTotals[header] || 0) + amount;
          });

          const netSalary = totalEarnings - totalDeductions;
          profitCenterTotals["TOTAL DEDN"] += totalDeductions;
          profitCenterTotals["NET AMT"] += netSalary;
          grandTotals["TOTAL DEDN"] += totalDeductions;
          grandTotals["NET AMT"] += netSalary;
        });

        const row = [
          index + 1,
          profitCenterName,
          formatValue(profitCenterTotals["ACTUAL PAY"]),
        ];

        earningsHeaders.forEach((header) =>
          row.push(formatValue(profitCenterTotals[header])),
        );
        row.push(formatCurrency(profitCenterTotals["TOTAL EARNINGS"]));

        deductionsHeaders.forEach((header) =>
          row.push(formatValue(profitCenterTotals[header])),
        );
        row.push(formatCurrency(profitCenterTotals["TOTAL DEDN"]));
        row.push(formatCurrency(profitCenterTotals["NET AMT"]));

        return row;
      },
    );

    // Grand total row
    const grandTotalRow = [
      {
        content: "Grand Total",
        colSpan: 2,
        styles: { fontStyle: "bold", halign: "left", valign: "middle" },
      },
      {
        content: formatValue(grandTotals["ACTUAL PAY"]),
        styles: { fontStyle: "bold", halign: "right", valign: "middle" },
      },
    ];

    [
      ...earningsHeaders,
      "TOTAL EARNINGS",
      ...deductionsHeaders,
      "TOTAL DEDN",
      "NET AMT",
    ].forEach((header) => {
      grandTotalRow.push({
        content: formatCurrency(grandTotals[header]),
        styles: { fontStyle: "bold", halign: "right", valign: "middle" },
      });
    });

    const body = [...tableData, grandTotalRow];

    // ── Column width & font logic (same as detailed & department reports) ──
    const totalCols = dynamicHeaders.length;
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const margin = 8;
    const availableWidth = pageWidth - 2 * margin;

    const baseWidths = {
      slNo: 18,
      profitCenter: 70, // similar to department width
      keyColumn: 38,
      regularColumn: 28,
    };

    let baseFontSize = 14;
    if (totalCols > 20) baseFontSize = 13;
    else if (totalCols > 16) baseFontSize = 13.5;
    else if (totalCols > 12) baseFontSize = 14;
    else if (totalCols > 8) baseFontSize = 14.5;

    const headFontSize = 12;

    // Calculate column widths
    const columnWidths = [];
    dynamicHeaders.forEach((header, index) => {
      if (index === 0) {
        columnWidths.push(baseWidths.slNo);
      } else if (index === 1) {
        columnWidths.push(baseWidths.profitCenter);
      } else if (
        ["ACTUAL PAY", "TOTAL EARNINGS", "TOTAL DEDN", "NET AMT"].includes(
          header,
        )
      ) {
        columnWidths.push(baseWidths.keyColumn);
      } else {
        columnWidths.push(baseWidths.regularColumn);
      }
    });

    // Scale to fit
    const totalWidthNeeded = columnWidths.reduce((sum, w) => sum + w, 0);
    const scaleFactor = availableWidth / totalWidthNeeded;
    columnWidths.forEach((w, i) => {
      columnWidths[i] = w * scaleFactor;
    });

    // Column styles
    const columnStyles = {};
    dynamicHeaders.forEach((header, index) => {
      let halign = index === 1 ? "left" : "right";
      if (index === 0) halign = "center";

      let fontSize = baseFontSize;
      if (index === 1) fontSize = baseFontSize - 0.5; // slightly smaller for long names

      columnStyles[index] = {
        cellWidth: columnWidths[index],
        halign,
        valign: "middle",
        fontSize,
      };
    });

    doc.autoTable({
      head: tableHeaders,
      body,
      startY: 45,
      theme: "grid",
      styles: {
        fontSize: baseFontSize,
        cellPadding: 2.5,
        valign: "middle",
        lineColor: [0, 0, 0],
        lineWidth: 0.3,
        minCellHeight: 12,
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        fontSize: headFontSize,
        halign: "center",
        valign: "middle",
        lineWidth: 0.3,
        lineColor: [0, 0, 0],
        minCellHeight: 10,
      },
      columnStyles,
      margin: { top: 45, left: margin, right: margin, bottom: 40 },
      tableWidth: "auto",
      didParseCell: (data) => {
        if (
          ["TOTAL EARNINGS", "TOTAL DEDN", "NET AMT"].includes(
            dynamicHeaders[data.column.index],
          )
        ) {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.halign = "right";
        }
      },
    });

    const finalY = doc.lastAutoTable.finalY;

    // Generated info
    doc.setFontSize(12);
    const today = new Date().toLocaleDateString("en-GB");
    doc.text(`Generated on: ${today}`, pageWidth - margin, finalY + 10, {
      align: "right",
    });
    doc.text(
      `Generated by: ${UserName || "User"}`,
      pageWidth - margin,
      finalY + 16,
      { align: "right" },
    );

    // Signature block
    addPageFooter(doc, finalY + 30);

    doc.save(`Payroll_ProfitCenter_Totals_Report_${monthNameAndYear}.pdf`);
  };

  const GeneratePayslip = (employeeId) => {
    const date = new Date(fromDate);

    // Format dates based on selectedOption
    let dateHeading;
    if (selectedOption === "Daily") {
      // Format the fromDate and toDate for display
      const formattedFromDate = new Intl.DateTimeFormat("en-US", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }).format(new Date(fromDate));

      const formattedToDate = new Intl.DateTimeFormat("en-US", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }).format(new Date(toDate));

      dateHeading = `PAYSLIP FROM ${formattedFromDate} TO ${formattedToDate}`;
    } else {
      // Use the original month and year format
      const monthNameAndYear = new Intl.DateTimeFormat("en-US", {
        month: "long",
        year: "numeric",
      }).format(date);
      dateHeading = `PAYSLIP FOR THE MONTH OF ${monthNameAndYear}`;
    }

    // Helper function for proper rounding and formatting
    const formatCurrency = (amount) => {
      // Round to nearest integer
      return Math.round(Number(amount)).toFixed(2);
    };

    // Helper function to safely display text
    const safeText = (value) => value || "N/A";

    // Helper function to convert numbers to words
    const numberToWords = (num) => {
      // Round the number before converting to words
      num = Math.round(num);
      const ones = [
        "",
        "One",
        "Two",
        "Three",
        "Four",
        "Five",
        "Six",
        "Seven",
        "Eight",
        "Nine",
        "Ten",
        "Eleven",
        "Twelve",
        "Thirteen",
        "Fourteen",
        "Fifteen",
        "Sixteen",
        "Seventeen",
        "Eighteen",
        "Nineteen",
      ];
      const tens = [
        "",
        "",
        "Twenty",
        "Thirty",
        "Forty",
        "Fifty",
        "Sixty",
        "Seventy",
        "Eighty",
        "Ninety",
      ];

      if (num === 0) return "Zero";

      // Handle rupees and paise
      const rupees = Math.floor(num);
      const paise = Math.round((num - rupees) * 100);

      // Convert rupees to words
      const convertRupees = (n) => {
        if (n === 0) return "";

        if (n < 20) return ones[n];

        if (n < 100) {
          return (
            tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + ones[n % 10] : "")
          );
        }

        if (n < 1000) {
          return (
            ones[Math.floor(n / 100)] +
            " Hundred" +
            (n % 100 !== 0 ? " and " + convertRupees(n % 100) : "")
          );
        }

        if (n < 100000) {
          return (
            convertRupees(Math.floor(n / 1000)) +
            " Thousand" +
            (n % 1000 !== 0 ? " " + convertRupees(n % 1000) : "")
          );
        }

        if (n < 10000000) {
          return (
            convertRupees(Math.floor(n / 100000)) +
            " Lakh" +
            (n % 100000 !== 0 ? " " + convertRupees(n % 100000) : "")
          );
        }

        return (
          convertRupees(Math.floor(n / 10000000)) +
          " Crore" +
          (n % 10000000 !== 0 ? " " + convertRupees(n % 10000000) : "")
        );
      };

      let result = convertRupees(rupees);

      // Add paise if applicable
      if (paise > 0) {
        result += " and " + convertRupees(paise) + " ";
      }

      return result + " ";
    };

    // Find the selected employee from PayrollData
    const employee = PayrollData.find((emp) => emp.EmpId === employeeId);
    console.log(employee, "employeee");

    if (!employee) {
      toast.error("Employee not found!");
      return;
    }

    // Filter additions and deductions for the selected employee
    const employeeAdditions = additionsDeductions.filter(
      (ad) =>
        ad.EmpId === employeeId &&
        ["Addition type", "Addition"].includes(ad.ComponentType),
    );

    // Sort additions to ensure "Basic" appears first
    const sortedAdditions = [...employeeAdditions].sort((a, b) => {
      // Check if component name contains "basic" (case insensitive)
      const aIsBasic = a.ComponentName.toLowerCase().includes("basic");
      const bIsBasic = b.ComponentName.toLowerCase().includes("basic");

      if (aIsBasic && !bIsBasic) return -1; // a comes first
      if (!aIsBasic && bIsBasic) return 1; // b comes first
      return 0; // keep original order
    });

    const employeeDeductions = additionsDeductions.filter(
      (ad) =>
        ad.EmpId === employeeId &&
        ["Deduction type", "Deduction"].includes(ad.ComponentType),
    );

    // Calculate totals with improved error handling
    const totalAdditions = sortedAdditions.reduce((total, ad) => {
      const amount =
        ad.ValueType === "Percentage"
          ? (Number(ad.BaseAmount || 0) * Number(ad.PercentageValue || 0)) / 100
          : Number(ad.CalculatedAmount || 0);
      return total + (isNaN(amount) ? 0 : amount);
    }, 0);

    const totalDeductions = employeeDeductions.reduce((total, ded) => {
      const amount =
        ded.ValueType === "Percentage" && ded.BaseAmount < 15000
          ? (Number(ded.BaseAmount || 0) * Number(ded.PercentageValue || 0)) /
            100
          : Number(ded.CalculatedAmount || 0);
      return total + (isNaN(amount) ? 0 : amount);
    }, 0);

    // Ensure numeric calculations and round values
    const workingDays = Number(employee.EmployeeTotalWorkingDays) || 0;
    const grossEarnings = Math.round(Number(totalAdditions));
    const netPay = Math.round(Number(employee.NetSalary));

    // Convert net pay to words
    const netPayInWords = numberToWords(netPay);

    // Create a new PDF document (A4 size, but we'll only use half of it)
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    // Define page dimensions - only use half of the page height
    const pageWidth = doc.internal.pageSize.width;
    const fullPageHeight = doc.internal.pageSize.height;
    const pageHeight = fullPageHeight / 2; // Use only half of the page
    const margin = 8;
    const contentWidth = pageWidth - margin * 2;

    // Define positions
    const middleX = pageWidth / 2;
    const middleOfContent = margin + contentWidth / 2;

    // Column positions for earnings/deductions table
    const leftColStart = margin + 2;
    const leftColValue = margin + 40;
    const rightColStart = middleOfContent + 5;
    const rightColValue = pageWidth - margin - 2;

    // Set smaller font sizes for compact layout
    const headerFontSize = 10;
    const subheaderFontSize = 8;
    const contentFontSize = 9;
    const smallFontSize = 6;

    // Add border around the payslip
    doc.rect(margin, margin, contentWidth, pageHeight - margin * 2);

    // Add header
    doc.setFont("helvetica", "bold");
    doc.setFontSize(headerFontSize);
    doc.text(`${companyDetails.Name.toUpperCase()}`, middleX, margin + 6, {
      align: "center",
    });

    // Add payslip date heading
    doc.setFontSize(subheaderFontSize);
    doc.text(dateHeading, middleX, margin + 12, { align: "center" });

    // Add horizontal line
    doc.line(margin, margin + 15, pageWidth - margin, margin + 15);

    // UPDATED EMPLOYEE DETAILS SECTION - Two Column Layout
    doc.setFont("helvetica", "normal");
    doc.setFontSize(contentFontSize);

    let currentY = margin + 20;

    // Helper function to wrap text and return lines
    const wrapText = (text, maxWidth) => {
      if (!text) return [""];

      const words = text.toString().split(" ");
      if (words.length === 0) return [""];

      const lines = [];
      let currentLine = words[0] || "";

      for (let i = 1; i < words.length; i++) {
        const word = words[i];
        const testLine = currentLine + " " + word;
        const testWidth = doc.getTextWidth(testLine);

        if (testWidth < maxWidth && testLine.length < 50) {
          currentLine = testLine;
        } else {
          lines.push(currentLine);
          currentLine = word;
        }
      }
      lines.push(currentLine);
      return lines.filter((line) => line.trim().length > 0);
    };

    // Define two columns for employee details
    const detailsCol1Width = contentWidth * 0.58;
    const detailsCol2Width = contentWidth * 0.38;
    const detailsCol1X = margin + 2;
    const detailsCol2X = margin + detailsCol1Width + 4;

    const lineGap = 4;
    const rowGap = 3;

    // COLUMN 1: Name, Designation, Department
    let col1Y = currentY;

    // Name
    const nameText = `Name: ${safeText(employee.Name)} (${safeText(
      employee.Code,
    )})`;
    const nameLines = wrapText(nameText, detailsCol1Width - 6);
    nameLines.forEach((line, index) => {
      doc.text(line, detailsCol1X, col1Y + index * lineGap);
    });
    col1Y += Math.max(nameLines.length * lineGap, lineGap) + rowGap;

    // Designation
    const designationText = `Desg: ${safeText(employee.DesignationName)}`;
    const designationLines = wrapText(designationText, detailsCol1Width - 6);
    designationLines.forEach((line, index) => {
      doc.text(line, detailsCol1X, col1Y + index * lineGap);
    });
    col1Y += Math.max(designationLines.length * lineGap, lineGap) + rowGap;

    // Department
    const departmentText = `Dept: ${safeText(employee.DepartmentName)}`;
    const departmentLines = wrapText(departmentText, detailsCol1Width - 6);
    departmentLines.forEach((line, index) => {
      doc.text(line, detailsCol1X, col1Y + index * lineGap);
    });

    // COLUMN 2: Attendance and Leave Details
    let col2Y = currentY;

    // Attendance
    const attendanceText = `Attendance: ${safeText(workingDays.toString())}`;
    doc.text(attendanceText, detailsCol2X, col2Y);
    col2Y += lineGap + rowGap;

    // Calculate LOP
    const lopValue = Math.max(
      0,
      (employee?.TotalWorkingDays ?? 0) -
        (employee?.PayrollDays ?? employee?.TotalWorkingDays ?? 0) -
        employee?.TotalHalfDay ??
        employee?.TotalHalfDay ??
        0,
    );

    // Leave details
    const leaveDetailsText = `Deduction: HD:${safeText(
      employee?.TotalHalfDay,
    )} | SL:${safeText(employee?.HalfSickLeave)} | LC:${safeText(
      employee?.LateCut,
    )} | LOP:${safeText(lopValue)}`;

    doc.setFontSize(smallFontSize);
    const leaveLines = wrapText(leaveDetailsText, detailsCol2Width - 4);
    leaveLines.forEach((line, index) => {
      doc.text(line, detailsCol2X, col2Y + index * 3);
    });
    col2Y += Math.max(leaveLines.length * 3, 3) + rowGap;

    // Leave Types
    doc.setFontSize(contentFontSize);
    const leaveTypeText = `Leaves: ${safeText(employee?.LeaveTypes)}`;
    const leaveTypeLines = wrapText(leaveTypeText, detailsCol2Width - 4);
    leaveTypeLines.forEach((line, index) => {
      doc.text(line, detailsCol2X, col2Y + index * lineGap);
    });

    col2Y += Math.max(leaveLines.length * 3, 3) + rowGap;

    // Leave Types
    doc.setFontSize(contentFontSize);
    const leaveTypehalf = `Halfdays paid ${safeText(
      employee?.TotalHalfDay_NOT_HalfDaysLOP_COUNT,
    )}`;
    const leaveTypelinehalf = wrapText(leaveTypehalf, detailsCol2Width - 4);
    leaveTypelinehalf.forEach((line, index) => {
      doc.text(line, detailsCol2X, col2Y + index * lineGap);
    });

    // Calculate the maximum Y position used by both columns
    const maxDetailsY = Math.max(
      col1Y + departmentLines.length * lineGap,
      col2Y + leaveTypeLines.length * lineGap,
    );
    currentY = Math.max(maxDetailsY + 6, currentY + 25); // Ensure minimum space

    // Add horizontal line after employee details
    const employeeDetailsEndY = currentY;
    doc.line(
      margin,
      employeeDetailsEndY,
      pageWidth - margin,
      employeeDetailsEndY,
    );

    // Add vertical line in the middle
    doc.line(
      middleOfContent,
      employeeDetailsEndY,
      middleOfContent,
      pageHeight - margin,
    );

    // Headers for earnings and deductions
    doc.setFont("helvetica", "bold");
    doc.text("EARNINGS", leftColValue - 15, currentY + 4, { align: "center" });
    doc.text("DEDUCTIONS", rightColValue - 25, currentY + 4, {
      align: "center",
    });

    // Add horizontal line below headers
    doc.line(margin, currentY + 6, pageWidth - margin, currentY + 6);
    currentY += 9;

    // Set font back to normal for data
    doc.setFont("helvetica", "normal");

    // Track the maximum Y position between earnings and deductions
    let earningsY = currentY;
    let deductionsY = currentY;
    const lineHeight = 4; // Very compact line height

    // Add ALL additions to Earnings (removed maxItems limitation)
    sortedAdditions.forEach((addition) => {
      if (addition?.ComponentName) {
        // Truncate component names if needed
        let componentName = String(addition.ComponentName);
        if (componentName.length > 15) {
          componentName = componentName.substring(0, 25);
        }
        doc.text(componentName, leftColStart, earningsY);
      }

      doc.text(
        formatCurrency(addition.CalculatedAmount),
        leftColValue + 15,
        earningsY,
        { align: "right" },
      );
      earningsY += lineHeight;
    });
    // Add ALL Deductions (removed maxItems limitation)
    employeeDeductions.forEach((deduction) => {
      if (deduction?.ComponentName) {
        // Truncate component names if needed
        let componentName = String(deduction.ComponentName);
        if (componentName.length > 15) {
          componentName = componentName.substring(0, 25);
        }
        doc.text(componentName, rightColStart, deductionsY);
      }

      if (deduction?.CalculatedAmount != null) {
        doc.text(
          formatCurrency(deduction.CalculatedAmount),
          rightColValue,
          deductionsY,
          { align: "right" },
        );
      }
      deductionsY += lineHeight;
    });

    // Find the maximum Y position between earnings and deductions
    const maxY = Math.max(earningsY, deductionsY) + 3;
    doc.line(margin, maxY, pageWidth - margin, maxY);

    let totalY = maxY + 5;
    doc.setFont("helvetica", "bold");

    // Gross earnings
    doc.text("GROSS EARNINGS", leftColStart, totalY);
    doc.text(formatCurrency(grossEarnings), leftColValue + 15, totalY, {
      align: "right",
    });

    // Total deduction
    doc.text("TOTAL DEDUCTION", rightColStart, totalY);
    doc.text(formatCurrency(totalDeductions), rightColValue, totalY, {
      align: "right",
    });

    totalY += 5;
    // Add horizontal line after totals but only on the right side
    doc.line(middleOfContent, totalY, pageWidth - margin, totalY);

    totalY += 5;
    // Net pay
    doc.text("NET PAY", rightColStart, totalY);
    doc.text(formatCurrency(netPay), rightColValue, totalY, { align: "right" });

    totalY += 7;
    // Add net pay in words with proper wrapping - max 2 lines
    doc.setFontSize(smallFontSize);
    doc.text("NET PAY IN WORDS:", leftColStart, totalY);

    totalY += 3;
    // Handle text wrapping for long amounts in words
    const wordsWidth = pageWidth - margin * 2 - 10;
    let netPayInWordsWithSuffix = netPayInWords + "only"; // Update to use "only" instead of "paise only"
    const wrappedText = doc.splitTextToSize(
      netPayInWordsWithSuffix,
      wordsWidth,
    );
    // Limit to 2 lines maximum
    const limitedText = wrappedText.slice(0, 2);
    if (wrappedText.length > 2) {
      limitedText[1] =
        limitedText[1].substring(0, limitedText[1].length - 3) + "...";
    }
    doc.text(limitedText, leftColStart, totalY);

    totalY += limitedText.length * 3 + 5;

    // Add horizontal line after net pay in words
    doc.line(margin, totalY, pageWidth - margin, totalY);

    // Secretary signature - position at fixed distance from bottom
    const signatureY = pageHeight - margin - 5;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(contentFontSize);
    doc.text("SECRETARY", rightColValue, signatureY, { align: "right" });

    // Generate appropriate filename
    let filenameDate;
    if (selectedOption === "Daily") {
      const fromDateObj = new Date(fromDate);
      const toDateObj = new Date(toDate);
      const fromDateStr = fromDateObj.toISOString().split("T")[0];
      const toDateStr = toDateObj.toISOString().split("T")[0];
      filenameDate = `${fromDateStr}_to_${toDateStr}`;
    } else {
      const monthNameAndYear = new Intl.DateTimeFormat("en-US", {
        month: "long",
        year: "numeric",
      }).format(date);
      filenameDate = monthNameAndYear;
    }

    // Download the PDF
    doc.save(`Payslip_${safeText(employee.Name)}_${filenameDate}.pdf`);
  };

  const handleMonthChange = (e) => {
    const selectedMonth = e.target.value;

    const [year, month] = selectedMonth.split("-");
    const firstDate = new Date(parseInt(year), parseInt(month) - 1, 1);
    const lastDate = new Date(parseInt(year), parseInt(month), 0);

    // Format dates with leading zeros if needed
    const formatDate = (date) => {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    };

    setFromDate(formatDate(firstDate));
  };

  const filterdPayrollData = datafilter?.filter((employe) => {
    if (!searchTerm) return true;
    const term = searchTerm.toLowerCase();
    return (
      employe.Name.toLowerCase().includes(term) ||
      employe.CategoryName.toLowerCase().includes(term) ||
      (employe.Code && employe.Code.toLowerCase().includes(term))
    );
  });

  const handleFilterPercentageChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedFilter(selectedValue);

    const filtered = PayrollData.filter((data) => {
      const netSalary = data.NetSalary;
      const basicPay = data.CurrentBasicPay;

      if (selectedValue === "above100") {
        return netSalary > basicPay;
      } else if (selectedValue === "below50") {
        return netSalary < 0.5 * basicPay;
      } else if (selectedValue === "below25") {
        return netSalary < 0.25 * basicPay;
      }
      return false;
    });

    setFilteredData(filtered);
  };

  const downloadFilteredDataPDF = (filteredData, selectedFilter) => {
    ////console.log("filteredData", PayrollData, additionsDeductions);

    const date = new Date(fromDate);

    // Format month and year
    const monthNameAndYear = new Intl.DateTimeFormat("en-US", {
      month: "long",
      year: "numeric",
    }).format(date);

    // Create PDF
    const doc = new jsPDF();

    // Centered title
    doc.setFontSize(16);
    const title = `Employees Net Salary ${selectedFilter}% Payroll Report for ${monthNameAndYear}`;
    const pageWidth = doc.internal.pageSize.getWidth();
    const titleWidth =
      (doc.getStringUnitWidth(title) * 16) / doc.internal.scaleFactor;
    doc.text(title, (pageWidth - titleWidth) / 2, 20);

    // Table columns
    const columns = [
      "Employee Code",
      "Employee Name",
      "Current Basic",
      "Net Salary",
    ];

    // Map data rows with required formatting
    const rows = filteredData?.map((item) => [
      item.Code,
      `${item.Name} (${item.Code})`,
      Number(item.CurrentBasicPay).toFixed(2),
      Number(Math.ceil(item.NetSalary)).toFixed(2), // Round up and show .00
    ]);

    // Generate the table
    doc.autoTable({
      head: [columns],
      body: rows,
      startY: 30,
      theme: "grid",
      styles: {
        fontSize: 10,
        cellPadding: 2,
        lineWidth: 0.5,
        lineColor: [0, 0, 0], // Black border for all cells
        textColor: [0, 0, 0], // Black text
      },
      headStyles: {
        fillColor: [240, 240, 240],
        textColor: [0, 0, 0],
        lineWidth: 0.8, // Thicker header border
        lineColor: [0, 0, 0],
      },
      bodyStyles: {
        lineColor: [0, 0, 0],
        lineWidth: 0.5,
      },
    });

    // Save the PDF
    doc.save(`Payroll_Report_${selectedFilter}_${monthNameAndYear}.pdf`);
  };

  const clearFilter = () => {
    setSelectedFilter("");
    setFilteredData(PayrollData);
  };

  const handleFilterChange = (selectedMethod, selectedOptionName) => {
    //(selectedMethod, 'Selected Method', selectedOptionName);
    setfilterdoption(selectedOptionName);
    setFilterMethod(selectedMethod);

    // Clone the original PayrollData to start filtering
    let filteredData = [...PayrollData];

    // Apply filtering based on the selected method
    if (selectedMethod === "DepartmentID") {
      filteredData = filteredData?.filter(
        (item) => item.DepartmentName === selectedOptionName,
      );
    } else if (selectedMethod === "DesignationId") {
      filteredData = filteredData?.filter(
        (item) => item.DesignationName === selectedOptionName,
      );
    } else if (selectedMethod === "ProfitCenterID") {
      filteredData = filteredData?.filter(
        (item) => item.ProfitCenterName === selectedOptionName,
      );
    } else if (selectedMethod === "CategoryId") {
      filteredData = filteredData?.filter(
        (item) => item.CategoryName === selectedOptionName,
      );
    } else if (selectedMethod === "GroupId") {
      filteredData = filteredData?.filter(
        (item) => item.GroupName === selectedOptionName,
      );
    }

    // Update the state with the filtered data
    setDataFilter(filteredData);

    //("Filtered Data:", filteredData);
  };

  const handleClearFilter = () => {
    setFilterMethod(""); // Clear the selected filter method
    setDataFilter(PayrollData); // Reset to the original unfiltered data
    //("Filters cleared. Showing all data.");
  };

  const ConsoldatedPdf = (filteredPayrollData, fromDate) => {
    // Create new PDF document
    const date = new Date(fromDate);

    // Use Intl.DateTimeFormat for formatted date string
    const monthNameAndYear = new Intl.DateTimeFormat("en-US", {
      month: "long",
      year: "numeric",
    }).format(date);
    //(monthNameAndYear, 'asdasasdasd');
    const doc = new jsPDF();

    // Set document properties
    doc.setProperties({
      title: `${companyDetails.Name.toUpperCase()} - Payroll Report`,
      subject: "Consolidated Employee Report",
      creator: "Payroll System",
    });

    // Define fonts and styles
    doc.setFont("helvetica", "bold");

    // Title and header - centered with minimal spacing
    doc.setFontSize(12);
    const title = `${companyDetails.Name.toUpperCase()}`;
    const titleWidth =
      (doc.getStringUnitWidth(title) * 12) / doc.internal.scaleFactor;
    const pageWidth = doc.internal.pageSize.width;
    doc.text(title, (pageWidth - titleWidth) / 2, 10);

    // Subtitle
    doc.setFontSize(11);
    const subtitle = "CONSOLIDATION OF PERMANENT EMPLOYEES";
    const subtitleWidth =
      (doc.getStringUnitWidth(subtitle) * 11) / doc.internal.scaleFactor;
    doc.text(subtitle, (pageWidth - subtitleWidth) / 2, 15);

    // Date
    const dateText = `Pay Roll for the Month of ${monthNameAndYear}`;
    const dateWidth =
      (doc.getStringUnitWidth(dateText) * 11) / doc.internal.scaleFactor;
    doc.text(dateText, (pageWidth - dateWidth) / 2, 20);

    // Group data by ProfitcenterName
    const groupedData = filteredPayrollData.reduce((acc, item) => {
      if (!acc[item.ProfitcenterName]) acc[item.ProfitcenterName] = [];
      acc[item.ProfitcenterName].push(item);
      return acc;
    }, {});

    let startY = 25;
    let grandTotal = 0;
    let pageCount = 1;

    // Define column widths and positions - adjusted to accommodate Code column
    const columns = {
      slNo: { x: 10, width: 12 },
      name: { x: 22, width: 65 },
      code: { x: 87, width: 20 },
      designation: { x: 107, width: 50 },
      netAmount: { x: 157, width: 30 },
    };

    // Very compact row height
    const rowHeight = 6;

    // Function to draw a cell with borders - minimal padding
    const drawCell = (
      x,
      y,
      width,
      height,
      text,
      isHeader = false,
      isRightAligned = false,
    ) => {
      // Draw cell border
      doc.setDrawColor(0);
      doc.setLineWidth(0.1);
      doc.rect(x, y - 4, width, height);

      // Set text style
      if (isHeader) {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(9);
      } else {
        doc.setFont("helvetica", "normal");
        doc.setFontSize(8);
      }

      // Add text with minimal padding
      if (isRightAligned) {
        const textWidth =
          (doc.getStringUnitWidth(text) * (isHeader ? 9 : 8)) /
          doc.internal.scaleFactor;
        doc.text(text, x + width - textWidth - 1, y);
      } else {
        doc.text(text, x + 1, y);
      }
    };

    // Function to draw table header
    const drawTableHeader = (y) => {
      drawCell(
        columns.slNo.x,
        y,
        columns.slNo.width,
        rowHeight,
        "SL. NO.",
        true,
      );
      drawCell(columns.name.x, y, columns.name.width, rowHeight, "NAME", true);
      drawCell(columns.code.x, y, columns.code.width, rowHeight, "CODE", true);
      drawCell(
        columns.designation.x,
        y,
        columns.designation.width,
        rowHeight,
        "DESIGNATION",
        true,
      );
      drawCell(
        columns.netAmount.x,
        y,
        columns.netAmount.width,
        rowHeight,
        "NET AMOUNT",
        true,
      );

      return y + rowHeight;
    };

    // Generate tables for each profit center
    Object.keys(groupedData).forEach((profitCenter) => {
      const data = groupedData[profitCenter];

      // Check if we need a new page
      if (startY > doc.internal.pageSize.height - 30) {
        doc.addPage();
        pageCount++;
        startY = 10;
      }

      // Section header with profit center name
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.text(profitCenter, 10, startY);

      // Reduced gap between section header and table
      startY += 5;
      startY = drawTableHeader(startY);

      // Add table rows
      let profitCenterTotal = 0;

      data.forEach((item, index) => {
        // Check if we need a new page
        if (startY > doc.internal.pageSize.height - 15) {
          doc.addPage();
          pageCount++;
          startY = 10;
          startY = drawTableHeader(startY);
        }

        // Serial number
        drawCell(
          columns.slNo.x,
          startY,
          columns.slNo.width,
          rowHeight,
          (index + 1).toString(),
        );

        // Name
        drawCell(
          columns.name.x,
          startY,
          columns.name.width,
          rowHeight,
          item.Name.toUpperCase(),
        );

        // Code - assuming the field exists in your data
        drawCell(
          columns.code.x,
          startY,
          columns.code.width,
          rowHeight,
          item.Code || "",
        );

        // Designation
        drawCell(
          columns.designation.x,
          startY,
          columns.designation.width,
          rowHeight,
          item.DesignationName,
        );

        // Net Amount (right aligned) - rounded to whole number with two decimal places
        const roundedNetSalary = Math.round(item.NetSalary);
        drawCell(
          columns.netAmount.x,
          startY,
          columns.netAmount.width,
          rowHeight,
          roundedNetSalary.toFixed(2),
          false,
          true,
        );

        profitCenterTotal += item.NetSalary;
        startY += rowHeight; // No extra spacing between rows
      });

      // Add profit center total
      grandTotal += profitCenterTotal;

      // Total row with spanning cells
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);

      // Draw total row with merged cells for "TOTAL:" label
      doc.setDrawColor(0);
      doc.setLineWidth(0.1);
      doc.rect(
        columns.slNo.x,
        startY - 4,
        columns.slNo.width +
          columns.name.width +
          columns.code.width +
          columns.designation.width,
        rowHeight,
      );
      doc.text("TOTAL:", columns.designation.x + 20, startY);

      // Draw total amount cell - rounded to whole number with two decimal places
      const roundedProfitCenterTotal = Math.round(profitCenterTotal);
      drawCell(
        columns.netAmount.x,
        startY,
        columns.netAmount.width,
        rowHeight,
        roundedProfitCenterTotal.toFixed(2),
        true,
        true,
      );

      // Minimal spacing between sections
      startY += rowHeight + 2;
    });

    // Check if we need a new page for grand total
    if (startY > doc.internal.pageSize.height - 20) {
      doc.addPage();
      pageCount++;
      startY = 15;
    }

    // Grand Total row
    doc.setFont("helvetica", "bold");
    doc.setFontSize(9);

    // Draw grand total row with merged cells for "GRAND TOTAL:" label
    doc.setDrawColor(0);
    doc.setLineWidth(0.1);
    doc.rect(
      columns.slNo.x,
      startY - 4,
      columns.slNo.width +
        columns.name.width +
        columns.code.width +
        columns.designation.width,
      rowHeight,
    );
    doc.text("GRAND TOTAL:", columns.designation.x + 10, startY);

    // Draw grand total amount cell - rounded to whole number with two decimal places
    const roundedGrandTotal = Math.round(grandTotal);
    drawCell(
      columns.netAmount.x,
      startY,
      columns.netAmount.width,
      rowHeight,
      roundedGrandTotal.toFixed(2),
      true,
      true,
    );

    // Add signature fields at the bottom with minimal margin
    startY = doc.internal.pageSize.height - 10;

    doc.setFontSize(9);
    doc.text("CLERK", 25, startY);
    doc.text("SUPERINTENDENT", 75, startY);
    doc.text("PRESIDENT", 135, startY);
    doc.text("SECRETARY", 180, startY);

    // Save PDF
    doc.save(`consolidated_payroll_report ${monthNameAndYear}.pdf`);
  };

  const SalaryStatement = (filteredPayrollData, fromDate) => {
    // Create new PDF document
    const date = new Date(fromDate);

    // Use Intl.DateTimeFormat for formatted date string
    const monthNameAndYear = new Intl.DateTimeFormat("en-US", {
      month: "long",
      year: "numeric",
    }).format(date);

    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;
    const leftMargin = 10;
    const rightMargin = 10;
    const contentWidth = pageWidth - leftMargin - rightMargin;

    // Set document properties
    doc.setProperties({
      title: `${companyDetails.Name.toUpperCase()} - Salary Statement`,
      subject: "Employee Salary Statement",
      creator: "Payroll System",
    });

    // Title with bold font
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    const title = `${companyDetails.Name.toUpperCase()}`;
    const titleWidth =
      (doc.getStringUnitWidth(title) * 11) / doc.internal.scaleFactor;
    doc.text(title, (pageWidth - titleWidth) / 2, 12);

    // // Subtitle
    // doc.setFontSize(9);
    // const subtitle = `${companyDetails.Address}`;
    // const subtitleWidth = doc.getStringUnitWidth(subtitle) * 9 / doc.internal.scaleFactor;
    // doc.text(subtitle, (pageWidth - subtitleWidth) / 2, 17);

    // Date text right after the subtitle
    const dateText =
      `Salary Statement for the Month of ${monthNameAndYear}`.toUpperCase();
    const dateWidth =
      (doc.getStringUnitWidth(dateText) * 9) / doc.internal.scaleFactor;
    doc.text(dateText, (pageWidth - dateWidth) / 2, 22);

    // Single full-width horizontal line after all three headings
    doc.setDrawColor(0);
    doc.setLineWidth(0.5);
    doc.line(leftMargin, 25, pageWidth - rightMargin, 25);

    // Reset to normal font weight for body text
    doc.setFont("helvetica", "normal");

    // Add bank details section
    doc.setFontSize(9);
    doc.text("To,", 10, 32);
    doc.text("The Manager,", 10, 37);
    doc.text("Dhanalakshmi Bank", 10, 42);
    // doc.text("Attukal", 10, 47);

    doc.text("Sir,", 10, 55);
    doc.text(
      `Kindly credit the salary of the ${companyDetails.Name} employees as below mentioned.`,
      10,
      60,
    );

    // Calculate total number of pages needed
    const calculateTotalPages = () => {
      // Each page can fit approximately 40 items, plus we need to account for headers and footers
      // Include calculation for table rows plus the total row at the end
      const itemsPerPage = 40;
      return Math.max(1, Math.ceil(filteredPayrollData.length / itemsPerPage));
    };

    const totalPages = calculateTotalPages();

    let startY = 70;
    let pageCount = 1;
    let itemCount = 0;

    // Define column widths and positions
    const columns = {
      slNo: { x: 10, width: 15 },
      name: { x: 25, width: 80 },
      accountNo: { x: 105, width: 40 },
      netAmount: { x: 145, width: 45 },
    };

    // Row height
    const rowHeight = 6;

    // Function to safely format a number with 2 decimal places
    const formatAmount = (value) => {
      // Handle various input types
      let numValue = 0;

      if (typeof value === "number") {
        numValue = value;
      } else if (typeof value === "string") {
        // Remove commas and try to parse
        numValue = parseFloat(value.replace(/,/g, "")) || 0;
      }

      return numValue.toFixed(2);
    };

    // Function to draw a table row with or without borders
    const drawRow = (y, slNo, name, accountNo, amount, isHeader = false) => {
      // Set font weight based on whether this is a header row
      doc.setFont("helvetica", isHeader ? "bold" : "normal");

      // Draw cell borders
      doc.setDrawColor(0);
      doc.setLineWidth(0.1);
      doc.rect(columns.slNo.x, y - 4, columns.slNo.width, rowHeight);
      doc.rect(columns.name.x, y - 4, columns.name.width, rowHeight);
      doc.rect(columns.accountNo.x, y - 4, columns.accountNo.width, rowHeight);
      doc.rect(columns.netAmount.x, y - 4, columns.netAmount.width, rowHeight);

      // Add text with appropriate font size
      doc.setFontSize(8);

      // SL. NO. column
      if (typeof slNo === "number") {
        // For numbers, center in the column
        const slNoWidth =
          (doc.getStringUnitWidth(slNo.toString()) * 8) /
          doc.internal.scaleFactor;
        const slNoX = columns.slNo.x + (columns.slNo.width - slNoWidth) / 2;
        doc.text(slNo.toString(), slNoX, y);
      } else {
        // For header text, left align
        doc.text(slNo.toString(), columns.slNo.x + 1, y);
      }

      // Employee name
      doc.text(name, columns.name.x + 1, y);

      // Account number
      if (accountNo) {
        doc.text(accountNo, columns.accountNo.x + 1, y);
      }

      // Format amount safely for display
      let amountText;
      if (amount === "Net Amount") {
        amountText = amount;
      } else {
        amountText =
          typeof amount === "number" || typeof amount === "string"
            ? formatAmount(amount)
            : "0.00";
      }

      // Right align amount
      const amountWidth =
        (doc.getStringUnitWidth(amountText) * 8) / doc.internal.scaleFactor;
      doc.text(
        amountText,
        columns.netAmount.x + columns.netAmount.width - amountWidth - 2,
        y,
      );
    };

    // Function to draw table header
    const drawTableHeader = (y) => {
      // Draw the header row with bold text
      drawRow(y, "SL. NO.", "Name", "Account No", "Net Amount", true);
      return y + rowHeight;
    };

    // Draw table header
    startY = drawTableHeader(startY);

    // Track total amount
    let totalAmount = 0;

    // Add data rows
    filteredPayrollData.forEach((item, index) => {
      itemCount++;

      // Check if we need a new page
      if (startY > doc.internal.pageSize.height - 20) {
        // Add page number at the bottom
        doc.setFontSize(8);
        doc.text(
          `Page ${pageCount} of ${totalPages}`,
          pageWidth / 2,
          doc.internal.pageSize.height - 10,
        );

        // Create new page
        doc.addPage();
        pageCount++;
        startY = 20;
        startY = drawTableHeader(startY);
      }

      // Safely parse the amount
      let amount = 0;
      if (typeof item.NetSalary === "number") {
        amount = item.NetSalary;
      } else if (typeof item.NetSalary === "string") {
        amount = parseFloat(item.NetSalary.replace(/,/g, "")) || 0;
      }

      totalAmount += amount;

      // Draw row with employee data (not a header)
      drawRow(
        startY,
        itemCount,
        item.Name ? `${item.Name.toUpperCase()} (${item.Code || ""})` : "",
        item.ACCNO || "",
        Math.round(amount),
        false,
      );

      startY += rowHeight;
    });

    // Check if we need a new page for total
    if (startY > doc.internal.pageSize.height - 25) {
      // Add page number at the bottom
      doc.setFontSize(8);
      doc.text(
        `Page ${pageCount} of ${totalPages}`,
        pageWidth / 2,
        doc.internal.pageSize.height - 10,
      );

      // Create new page
      doc.addPage();
      pageCount++;
      startY = 20;
    }

    // Add total row with bold text
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    doc.text("TOTAL:", columns.name.x + 1, startY);

    // Draw border for total row
    doc.setDrawColor(0);
    doc.setLineWidth(0.1);
    doc.rect(
      columns.slNo.x,
      startY - 4,
      columns.slNo.width + columns.name.width + columns.accountNo.width,
      rowHeight,
    );
    doc.rect(
      columns.netAmount.x,
      startY - 4,
      columns.netAmount.width,
      rowHeight,
    );

    // Format and right align total amount
    const roundedTotal = Math.round(totalAmount);
    const totalText = formatAmount(roundedTotal);
    const totalWidth =
      (doc.getStringUnitWidth(totalText) * 8) / doc.internal.scaleFactor;
    doc.text(
      totalText,
      columns.netAmount.x + columns.netAmount.width - totalWidth - 2,
      startY,
    );

    // Add "Generated by" information on bottom left
    const today = new Date();
    const generatedText = `Generated on: ${today.toLocaleDateString("en-GB")}`;
    const generatedBy = `Generated by: ${UserName}`;

    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(0, 0, 0);

    // Position "Generated by" information on the bottom left
    doc.text(generatedText, leftMargin, doc.internal.pageSize.height - 20);
    doc.text(generatedBy, leftMargin, doc.internal.pageSize.height - 16);

    // Add signature on the bottom right
    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");
    // Position SECRETARY on the bottom right with proper spacing
    doc.text("SECRETARY", pageWidth - 30, doc.internal.pageSize.height - 20);

    // Add page numbering at the bottom center
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.text(
      `Page ${pageCount} of ${totalPages}`,
      pageWidth / 2,
      doc.internal.pageSize.height - 10,
    );

    // Save PDF
    doc.save(`salary_statement_${monthNameAndYear}.pdf`);
  };

  const PfStatement = (filteredPayrollData) => {
    console.log(filteredPayrollData, "Filtered Payroll Data");

    const date = new Date(fromDate);
    const payrollEmpIds = filteredPayrollData.map((e) => e.EmpId);

    const filteredPfData = pfData.filter((e) =>
      payrollEmpIds.includes(e.EmpId),
    );

    const monthNameAndYear = new Intl.DateTimeFormat("en-US", {
      month: "long",
      year: "numeric",
    }).format(date);

    const groupedData = filteredPfData?.reduce((acc, item) => {
      acc[item.ProfitcenterName] = acc[item.ProfitcenterName] || [];
      acc[item.ProfitcenterName].push(item);
      return acc;
    }, {});

    const doc = new jsPDF();

    const heading = `PF Statement for the Month of ${monthNameAndYear}`;
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text(heading, 105, 10, { align: "center" });

    const subHeading = "PF STATEMENT ASSOCIATED WITH SALARY BILL";
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.text(subHeading, 105, 20, { align: "center" });

    let currentY = 30;

    let grandTotalAmount = 0;
    let grandTotalEPF = 0;
    let grandTotalEmployerContribution = 0;
    let grandTotalEmployeeContribution = 0;

    // Get contribution percentages from first record
    const employeeContribPct = parseFloat(
      filteredPfData[0]?.EmployeeContributionPct || 0,
    );
    const employerContribPct = parseFloat(
      filteredPfData[0]?.EmployerContributionPct || 0,
    );
    const epfMinLimit = parseFloat(filteredPfData[0]?.EPFMinLimit || 0);

    // EPF wage ceiling (standard EPFO cap)
    const epfWageCeiling = 15000;

    for (const [profitCenter, employees] of Object.entries(groupedData)) {
      if (currentY > 250) {
        doc.addPage();
        currentY = 20;
      }

      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text(profitCenter, 10, currentY);
      currentY += 10;

      const wageTypeName = employees[0]?.WageTypeName || "";
      const wageTypeLines = wageTypeName.match(/.{1,15}/g) || [wageTypeName];
      const amountHeader = ["Amount", ...wageTypeLines].join("\n");

      const columns = [
        "NO.",
        "EMPLOYEE NAME",
        amountHeader,
        `EPF\n(${epfMinLimit}%)`,
        `PF EMPLOYER\n(${employerContribPct}%)`,
        `PF EMPLOYEE\n(${employeeContribPct}%)`,
      ];

      let deptTotalAmount = 0;
      let deptTotalEPF = 0;
      let deptTotalEmployerContribution = 0;
      let deptTotalEmployeeContribution = 0;

      const data = employees.map((el, index) => {
        // Use PFBaseAmount as base, capped at EPF wage ceiling
        const pfBaseAmount = Math.round(el.PFBaseAmount || 0);
        const epfBase = Math.min(pfBaseAmount, epfWageCeiling);

        // ✅ Recalculate correctly from the base amount using percentages
        const epfAmount = Math.round(epfBase * (epfMinLimit / 100));
        const employerContribution = Math.round(
          epfBase * (employerContribPct / 100),
        );
        const employeeContribution = Math.round(
          epfBase * (employeeContribPct / 100),
        );

        deptTotalAmount += pfBaseAmount;
        deptTotalEPF += epfAmount;
        deptTotalEmployerContribution += employerContribution;
        deptTotalEmployeeContribution += employeeContribution;

        return [
          index + 1,
          el.EmployeeName || "N/A",
          pfBaseAmount + ".00",
          epfAmount + ".00",
          employerContribution + ".00",
          employeeContribution + ".00",
        ];
      });

      // Department total row
      data.push([
        "",
        "TOTAL",
        deptTotalAmount + ".00",
        deptTotalEPF + ".00",
        deptTotalEmployerContribution + ".00",
        deptTotalEmployeeContribution + ".00",
      ]);

      grandTotalAmount += deptTotalAmount;
      grandTotalEPF += deptTotalEPF;
      grandTotalEmployerContribution += deptTotalEmployerContribution;
      grandTotalEmployeeContribution += deptTotalEmployeeContribution;

      doc.autoTable({
        head: [columns],
        body: data,
        startY: currentY,
        theme: "grid",
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          fontStyle: "bold",
          halign: "center",
        },
        bodyStyles: {
          textColor: [0, 0, 0],
          halign: "center",
        },
        styles: {
          fontSize: 8,
          cellPadding: 2,
          lineColor: [0, 0, 0],
          lineWidth: 0.1,
          overflow: "linebreak",
        },
        didParseCell: function (data) {
          if (data.row.index === data.table.body.length - 1) {
            data.cell.styles.fontStyle = "bold";
          }
        },
      });

      currentY = doc.previousAutoTable.finalY + 15;
    }

    // Grand Total Section
    if (currentY > 240) {
      doc.addPage();
      currentY = 20;
    }

    currentY += 10;

    const grandTotalColumns = [
      "",
      "AMOUNT",
      `EPF\n(${epfMinLimit}%)`,
      `PF EMPLOYER\n(${employerContribPct}%)`,
      `PF EMPLOYEE\n(${employeeContribPct}%)`,
    ];

    const grandTotalData = [
      [
        "GRAND TOTAL",
        grandTotalAmount + ".00",
        grandTotalEPF + ".00",
        grandTotalEmployerContribution + ".00",
        grandTotalEmployeeContribution + ".00",
      ],
    ];

    doc.autoTable({
      head: [grandTotalColumns],
      body: grandTotalData,
      startY: currentY,
      theme: "grid",
      headStyles: {
        fillColor: [200, 200, 200],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
        fontSize: 10,
      },
      bodyStyles: {
        textColor: [0, 0, 0],
        halign: "center",
        fontStyle: "bold",
        fontSize: 10,
        fillColor: [240, 240, 240],
      },
      styles: {
        fontSize: 10,
        cellPadding: 3,
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
        overflow: "linebreak",
      },
    });

    currentY = doc.previousAutoTable.finalY + 20;

    // Signature Section
    if (currentY > 240) {
      doc.addPage();
      currentY = 20;
    }

    const signaturePositions = [
      { title: "Clerk", x: 20 },
      { title: "Jr. Superintendent", x: 70 },
      { title: "A.O.", x: 120 },
      { title: "Superintendent", x: 150 },
      { title: "President", x: 180 },
      { title: "Secretary", x: 210 },
    ];

    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");

    signaturePositions.forEach((pos) => {
      doc.line(pos.x, currentY + 15, pos.x + 35, currentY + 15);
      doc.text(pos.title, pos.x + 17, currentY + 22, { align: "center" });
    });

    doc.save(`PF_Statement_${monthNameAndYear.replace(" ", "_")}.pdf`);
  };

  const EsiStatement = (filteredPayrollData) => {
    if (Esidata.length == 0) {
      toast.error("No ESI data");
      return;
    }

    const date = new Date(fromDate);
    const payrollEmpIds = filteredPayrollData.map((e) => e.EmpId);
    const filteredEsiData = Esidata.filter((e) =>
      payrollEmpIds.includes(e.EmpId),
    );

    // Use Intl.DateTimeFormat for formatted date string
    const monthNameAndYear = new Intl.DateTimeFormat("en-US", {
      month: "long",
      year: "numeric",
    }).format(date);

    // Group data by ProfitcenterName
    const groupedData = filteredEsiData?.reduce((acc, item) => {
      acc[item.ProfitcenterName] = acc[item.ProfitcenterName] || [];
      acc[item.ProfitcenterName].push(item);
      return acc;
    }, {});

    // Create a new jsPDF instance
    const doc = new jsPDF();

    // Define the heading
    const heading = `ESI Statement for the Month of ${monthNameAndYear}`;
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text(heading, 105, 10, { align: "center" });

    // Add sub-heading
    const subHeading = "ESI STATEMENT ASSOCIATED WITH SALARY BILL";
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.text(subHeading, 105, 20, { align: "center" });

    let currentY = 30; // Initial Y position

    // Initialize grand totals
    let grandTotalESIBase = 0;
    let grandTotalEmployeeESI = 0;
    let grandTotalEmployerESI = 0;
    let grandTotalESI = 0;

    // Get ESI percentages from actual data (from first record)
    const employeeESIPercentage = filteredEsiData[0]?.EmployeeContribution;
    const employerESIPercentage = filteredEsiData[0]?.EmployerContribution;

    // Loop through grouped data
    for (const [department, employees] of Object.entries(groupedData)) {
      // Check if we need a new page
      if (currentY > 250) {
        doc.addPage();
        currentY = 20;
      }

      // Add department name as a subheading
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text(department, 10, currentY);
      currentY += 10;

      // Get WageTypeName from first employee in department, wrap at 15 chars
      const wageTypeName = employees[0]?.WageTypeName || "";
      const wageTypeLines = wageTypeName.match(/.{1,45}/g) || [wageTypeName];
      const amountHeader = ["Amount", ...wageTypeLines].join("\n");

      // Table columns with percentages in header (using actual values)
      const columns = [
        "SL.",
        "EMPLOYEE NAME",
        amountHeader,
        `EMPLOYEE\n(${employeeESIPercentage}%)`,
        `EMPLOYER\n(${employerESIPercentage}%)`,
        "TOTAL ESI",
      ];

      // Initialize department totals
      let deptTotalESIBase = 0;
      let deptTotalEmployeeESI = 0;
      let deptTotalEmployerESI = 0;
      let deptTotalESI = 0;

      // Generate table data for the department - USE PRE-CALCULATED VALUES
      const data = employees.map((el, index) => {
        // Use pre-calculated integer values from stored procedure
        const pay = el.FinalBasic || 0;
        const daAmount = el.DaAmount || 0;
        const esiBase = pay + daAmount;
        const employeeESI = el.ESIamount_Employee || 0; // ✅ Pre-calculated
        const employerESI = el.ESIamount_Employer || 0; // ✅ Pre-calculated
        const totalESI = employeeESI + employerESI;

        // Add to department totals
        deptTotalESIBase += esiBase;
        deptTotalEmployeeESI += employeeESI;
        deptTotalEmployerESI += employerESI;
        deptTotalESI += totalESI;

        return [
          index + 1, // Serial number
          el.EmployeeName || "N/A",
          esiBase + ".00", // Already integer
          employeeESI + ".00", // Already integer from DB
          employerESI + ".00", // Already integer from DB
          totalESI + ".00",
        ];
      });

      // Add department total row
      data.push([
        "",
        "TOTAL",
        Math.round(deptTotalESIBase) + ".00",
        Math.round(deptTotalEmployeeESI) + ".00",
        Math.round(deptTotalEmployerESI) + ".00",
        Math.round(deptTotalESI) + ".00",
      ]);

      // Add to grand totals
      grandTotalESIBase += deptTotalESIBase;
      grandTotalEmployeeESI += deptTotalEmployeeESI;
      grandTotalEmployerESI += deptTotalEmployerESI;
      grandTotalESI += deptTotalESI;

      // AutoTable settings
      doc.autoTable({
        head: [columns],
        body: data,
        startY: currentY,
        theme: "grid",
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          fontStyle: "bold",
          halign: "center",
        },
        bodyStyles: {
          textColor: [0, 0, 0],
          halign: "center",
        },
        styles: {
          fontSize: 8,
          cellPadding: 2,
          lineColor: [0, 0, 0],
          lineWidth: 0.1,
          overflow: "linebreak", // ✅ enables \n line breaks in headers
        },
        didParseCell: function (data) {
          // Make total row bold
          if (data.row.index === data.table.body.length - 1) {
            data.cell.styles.fontStyle = "bold";
          }
        },
      });

      // Update Y position for next department
      currentY = doc.previousAutoTable.finalY + 15;
    }

    // Add Grand Total Section
    if (currentY > 240) {
      doc.addPage();
      currentY = 20;
    }

    // Add some space before grand total
    currentY += 10;

    // Create grand total table - matching main table columns only
    const grandTotalColumns = [
      "",
      "AMOUNT",
      `EMPLOYEE\n(${employeeESIPercentage}%)`,
      `EMPLOYER\n(${employerESIPercentage}%)`,
      "TOTAL ESI",
    ];

    const grandTotalData = [
      [
        "GRAND TOTAL",
        Math.round(grandTotalESIBase) + ".00",
        Math.round(grandTotalEmployeeESI) + ".00",
        Math.round(grandTotalEmployerESI) + ".00",
        Math.round(grandTotalESI) + ".00",
      ],
    ];

    doc.autoTable({
      head: [grandTotalColumns],
      body: grandTotalData,
      startY: currentY,
      theme: "grid",
      headStyles: {
        fillColor: [200, 200, 200],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
        fontSize: 10,
      },
      bodyStyles: {
        textColor: [0, 0, 0],
        halign: "center",
        fontStyle: "bold",
        fontSize: 10,
        fillColor: [240, 240, 240],
      },
      styles: {
        fontSize: 10,
        cellPadding: 3,
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
        overflow: "linebreak",
      },
    });

    // Update Y position after grand total
    currentY = doc.previousAutoTable.finalY + 20;

    // Add signature section
    if (currentY > 240) {
      doc.addPage();
      currentY = 20;
    }

    // Signature positions
    const signaturePositions = [
      { title: "Clerk", x: 15 },
      { title: "Jr. Superintendent", x: 45 },
      { title: "A.O.", x: 80 },
      { title: "Superintendent", x: 110 },
      { title: "President", x: 140 },
      { title: "Secretary", x: 165 },
      { title: "Treasurer", x: 185 },
    ];

    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");

    signaturePositions.forEach((pos) => {
      doc.text(pos.title, pos.x + 8, currentY + 22, { align: "center" });
    });

    // Save the PDF
    doc.save(`ESI_Statement_${monthNameAndYear.replace(" ", "_")}.pdf`);
  };

  const handleFetchEmployeeMonthlyDetailed = async () => {
    if (!fromMonth || !toMonth || !selectedOption) {
      toast.error("Choose From, To Month, and Option");
      return;
    }

    const data = {
      fromMonth,
      toMonth,
      option: selectedOption,
      UserId: UID,
    };

    try {
      const response = await getMonthlyDetailedEmployeepayroll(data);

      if (response.status !== 201) {
        toast.error("Unexpected response status");
        return;
      }

      const payrollList = response.data?.data?.employeePayroll || [];

      // ✅ Parse Additions & Deductions safely
      const parsedData = payrollList.map((emp) => ({
        ...emp,
        Additions: emp.Additions ? JSON.parse(emp.Additions) : [],
        Deductions: emp.Deductions ? JSON.parse(emp.Deductions) : [],
      }));

      console.log(parsedData, "Parsed Payroll Data");

      toast.success("Data Fetched. Download now.");
      setDetailedMonthlyPayroll(parsedData);
    } catch (error) {
      console.error("Fetch Error:", error);
      toast.error("Failed to fetch payroll data");
    }
  };

  useEffect(() => {
    // Get the current date
    const currentDate = new Date();

    // Calculate the first day of the current month
    const firstDay = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      2,
    );

    // Calculate the last day of the current month
    const lastDay = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      1,
    );

    // Format dates to YYYY-MM-DD
    const formatDate = (date) => date.toISOString().split("T")[0];

    // Set default dates
    setFromDate(formatDate(firstDay));
    setToDate(formatDate(lastDay));
  }, []);

  useEffect(() => {
    fetchCompanyDetails();
    fetchOptions();
    getPFData();
    fetchcategory();
    fetchfilterProfitecenter();
    fetchDepartment();
    fetchGroup();
    fetchdesignation();
  }, [UID]);

  useEffect(() => {
    fetchData();
  }, [selectedOption]);

  useEffect(() => {
    setDataFilter(filteredData);
  }, [filteredData]);

  useEffect(() => {
    switch (filterMethod) {
      case "CategoryId":
        setDropdownOptions(category?.data?.data);
        break;
      case "ProfitCenterID":
        setDropdownOptions(FilterProfitcenter?.data?.data);
        break;
      case "GroupId":
        setDropdownOptions(group?.data?.data);
        break;

      case "DesignationId":
        setDropdownOptions(designation?.data?.data);
        break;
      case "DepartmentID":
        setDropdownOptions(Department?.data?.data);
        break;
      default:
        setDropdownOptions([]);
        break;
    }
  }, [
    filterMethod,
    category,
    FilterProfitcenter,
    group,
    designation,
    Department,
  ]);

  useEffect(() => {
    setDataFilter(PayrollData);
  }, [PayrollData]);

  const handleFilterReport = () => {
    setReportSelect(true);
  };

  return (
    <>
      {isAdditionsModalOpen && (
        <div
          className="fixed top-0 left-0 w-full h-full  bg-opacity-60 flex justify-center items-center z-50 backdrop-blur-sm"
          onClick={toggleAdditionsModal} // Close modal when clicking outside
        >
          <div
            className="bg-white rounded-lg p-6 w-1/2"
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal
          >
            <h2 className="text-xl font-bold mb-4">Additions Details</h2>

            {/* Render Addition Fields */}
            {isAdditionsModalOpen && (
              <div
                className="fixed top-0 left-0 w-full h-full  bg-opacity-30 flex justify-center items-center z-50 backdrop-blur-sm"
                onClick={toggleAdditionsModal} // Close modal when clicking outside
              >
                <div
                  className="bg-white rounded-lg p-6 w-1/2"
                  onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal
                >
                  {/* Add Addition Button */}

                  {/* Render Addition Fields */}
                  {isAdditionsModalOpen && (
                    <div
                      className="fixed top-0 left-0 w-full h-full bg-opacity-30 flex justify-center items-center z-50 backdrop-blur-sm"
                      onClick={toggleAdditionsModal} // Close modal when clicking outside
                    >
                      <div
                        className="bg-white rounded-lg p-6 w-1/2 max-h-[80vh] overflow-y-auto"
                        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal
                      >
                        <h2 className="text-xl font-bold mb-4">
                          Additions Details
                        </h2>
                        <div className="space-y-4">
                          {additionsDeductions
                            .filter(
                              (l) =>
                                l.EmpId === employeeId &&
                                (l.ComponentType === "Addition type" ||
                                  l.ComponentType === "Addition"),
                            )
                            ?.map((AD) => (
                              <div
                                key={AD.ComponentId}
                                className="p-4 bg-gray-50 rounded-lg shadow-lg border border-gray-300 mb-4"
                              >
                                {/* ComponentName as Main Heading */}
                                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                                  {AD.ComponentName}
                                  <span className="text-sm text-gray-500 ml-1">
                                    (Wage component)
                                  </span>
                                </h3>

                                {/* WageTypeName as Sub-heading */}
                                {AD.WageTypeName && (
                                  <h4 className="text-md text-gray-700 mb-3">
                                    {AD.WageTypeName}
                                    <span className="text-sm text-gray-400 ml-1">
                                      (WageType)
                                    </span>
                                  </h4>
                                )}

                                {/* Amount and Percentage Details */}
                                <div className="space-y-3">
                                  <div className="flex justify-between text-sm">
                                    <span className="text-gray-700">
                                      Base Amount:
                                    </span>
                                    <span className="font-semibold text-gray-900">
                                      {AD.WageTypeId === null ||
                                      AD.WageTypeId === undefined ? (
                                        <>-</>
                                      ) : (
                                        <>
                                          ₹
                                          {Math.round(AD.BaseAmount)?.toFixed(
                                            2,
                                          )}
                                        </>
                                      )}
                                    </span>
                                  </div>

                                  {AD.ValueType === "Percentage" && (
                                    <div className="flex justify-between text-sm">
                                      <span className="text-gray-700">
                                        Percentage:
                                      </span>
                                      <span className="font-semibold text-gray-900">
                                        {AD.PercentageValue}%
                                      </span>
                                    </div>
                                  )}

                                  <div className="flex justify-between text-sm">
                                    <span className="text-gray-700">
                                      Calculated Amount:
                                    </span>
                                    <span className="font-semibold text-gray-900">
                                      {Math.round(AD.CalculatedAmount)?.toFixed(
                                        2,
                                      )}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ))}

                          {/* Total Additions */}
                          <div className="p-4 bg-white rounded-lg shadow-md border border-gray-200">
                            <div className="flex justify-between text-sm">
                              <span className="text-gray-600 font-semibold">
                                Total Additions:
                              </span>
                              <span className="text-lg font-bold text-gray-900">
                                {Math.round(
                                  additionsDeductions
                                    .filter(
                                      (l) =>
                                        l.EmpId === employeeId &&
                                        l.ComponentType === "Addition",
                                    )
                                    .reduce((total, AD) => {
                                      const amount =
                                        AD.ValueType === "Percentage"
                                          ? (AD.BaseAmount *
                                              AD.PercentageValue) /
                                            100
                                          : AD.CalculatedAmount;
                                      return total + amount;
                                    }, 0),
                                ).toFixed(2)}
                              </span>
                            </div>
                          </div>
                        </div>

                        {/* Save and Cancel Buttons */}
                        <div className="flex justify-end mt-6 space-x-4">
                          <button
                            onClick={toggleAdditionsModal}
                            className="btn btn-primary"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Save and Cancel Buttons */}
                </div>
              </div>
            )}
            {/* Add and Save Buttons */}
          </div>
        </div>
      )}

      {isDeductionsModalOpen && (
        <div
          className="fixed top-0 left-0 w-full h-full  bg-opacity-30 flex justify-center items-center z-50 backdrop-blur-sm"
          onClick={toggleDeductionsModal} // Close modal when clicking outside
        >
          <div
            className="bg-white rounded-lg p-6 w-1/2"
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal
          >
            <h2 className="text-xl font-bold mb-4">Deductions Details</h2>

            <div
              style={{
                fontFamily: "Arial, sans-serif",
                maxWidth: "100%",
                margin: "20px auto",
                padding: "20px",
                border: "1px solid #ddd",
                borderRadius: "10px",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                backgroundColor: "#fff",
                height: "500px", // 👈 Set a fixed height
                overflowY: "auto",
              }}
            >
              {/* Header */}
              <h2
                style={{
                  textAlign: "center",
                  color: "#333",
                  marginBottom: "20px",
                }}
              >
                Deductions Receipt
              </h2>

              {/* Deductions List */}
              {additionsDeductions
                .filter(
                  (l) =>
                    l.EmpId === employeeId && l.ComponentType === "Deduction",
                )
                ?.map((AD) => {
                  const isPercentage = AD.ValueType === "Percentage";
                  const calculatedAmount =
                    isPercentage && AD.BaseAmount < 15000
                      ? (AD.BaseAmount * AD.PercentageValue) / 100
                      : AD.CalculatedAmount;

                  return (
                    <div
                      key={AD.ComponentId}
                      style={{
                        marginBottom: "15px",
                        padding: "15px",
                        borderBottom: "1px solid #eee",
                      }}
                    >
                      {/* ComponentName as Main Heading */}
                      <h3 style={{ color: "#444", marginBottom: "10px" }}>
                        {AD.ComponentName}
                      </h3>

                      {/* WageTypeName as Sub-heading */}
                      {AD.WageTypeName && (
                        <h4 style={{ color: "#666", marginBottom: "5px" }}>
                          {AD.WageTypeName}
                        </h4>
                      )}

                      {/* Amount and Percentage Details */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "5px",
                        }}
                      >
                        <span style={{ color: "#444" }}>Base Amount:</span>
                        <span style={{ fontWeight: "bold", color: "#444" }}>
                          {AD.WageTypeId === null ||
                          AD.WageTypeId === undefined ? (
                            <>-</>
                          ) : (
                            <>₹{AD.BaseAmount}</>
                          )}
                        </span>
                      </div>
                      {isPercentage && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "5px",
                          }}
                        >
                          <span style={{ color: "#444" }}>Percentage:</span>
                          <span style={{ fontWeight: "bold", color: "#444" }}>
                            {AD.PercentageValue}%
                          </span>
                        </div>
                      )}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginTop: "5px",
                        }}
                      >
                        <span style={{ color: "#444" }}>
                          Calculated Amount:
                        </span>
                        <span style={{ fontWeight: "bold", color: "#444" }}>
                          {Math.round(calculatedAmount).toFixed(2)}
                        </span>
                      </div>
                    </div>
                  );
                })}

              {/* Total Deductions */}
              <div className="p-4 bg-white rounded-lg shadow-md border border-gray-200">
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600 font-semibold">
                    Total Deductions:
                  </span>
                  <span className="text-lg font-bold text-gray-900">
                    {Math.round(
                      additionsDeductions
                        .filter(
                          (l) =>
                            l.EmpId === employeeId &&
                            (l.ComponentType === "Deduction type" ||
                              l.ComponentType === "Deduction"),
                        )
                        .reduce((total, AD) => {
                          const amount =
                            AD.ValueType === "Percentage" &&
                            AD.BaseAmount < 15000
                              ? (AD.BaseAmount * AD.PercentageValue) / 100
                              : AD.CalculatedAmount;

                          return total + Number(amount);
                        }, 0),
                    ).toFixed(2)}
                  </span>
                </div>
              </div>
            </div>

            {/* Save and Close Buttons */}
            <div className="flex justify-end gap-2 mt-4">
              {/* <button onClick={handleSave} className="btn btn-success">
                Save
              </button> */}
              <button
                onClick={toggleDeductionsModal}
                className="btn btn-primary"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {reportSelect && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          {/* Backdrop with blur */}
          <div
            className="absolute inset-0  bg-opacity-50 backdrop-blur-sm"
            onClick={() => setReportSelect(false)} // Close when clicking outside
          ></div>

          {/* Modal Content */}
          <div className="relative bg-white rounded-2xl shadow-2xl max-w-5xl w-full mx-4 max-h-[90vh] overflow-y-auto">
            {/* Optional Close Button */}
            <button
              onClick={() => setReportSelect(false)}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 z-10"
            >
              <svg
                className="w-8 h-8"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            {/* Your ColumnSelector */}
            <ColumnSelector
              columnsData={columnsData}
              onSave={(data) => {
                // Handle save if needed
                setReportSelect(false); // Close modal on save
              }}
            />
          </div>
        </div>
      )}
      <div className="p-4">
        <Breadcrumb title="Payroll Report" />
        <div className="flex flex-col md:flex-row items-center gap-4 w-full mb-4">
          <div className="flex flex-wrap items-center gap-4 w-full">
            {/* Salary Options Dropdown - FIRST */}
            <div className="flex flex-col">
              <label htmlFor="salary-options" className="text-sm mb-1">
                Salary Option
              </label>
              <select
                id="salary-options"
                className="border rounded p-2 w-[200px]"
                value={selectedOption}
                onChange={handleSelectChange}
              >
                {salaryOptions.map((option, index) => (
                  <option key={index} value={option.OptionName}>
                    {option.OptionName}
                  </option>
                ))}
              </select>
            </div>

            {/* Month Picker - SECOND */}

            {selectedOption === "Monthly" ? (
              <div className="flex flex-col">
                <label htmlFor="choose-month" className="text-sm mb-1">
                  Choose Month
                </label>
                <input
                  type="month"
                  id="choose-month"
                  className="border rounded p-2 w-[200px]"
                  onChange={handleMonthChange}
                />
              </div>
            ) : (
              <div className="flex gap-4 mt-4">
                <div className="flex flex-col">
                  <label htmlFor="from-date" className="text-sm mb-1">
                    From Date
                  </label>
                  <input
                    type="date"
                    id="from-date"
                    className="border rounded p-2 w-[200px]"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                  />
                </div>
                <div className="flex flex-col">
                  <label htmlFor="to-date" className="text-sm mb-1">
                    To Date
                  </label>
                  <input
                    type="date"
                    id="to-date"
                    className="border rounded p-2 w-[200px]"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                  />
                </div>
              </div>
            )}

            {/* View Button - THIRD */}
            <button
              type="button"
              className="btn btn-success mt-6"
              onClick={handleViewClick}
            >
              View
            </button>

            {/* Filter Method Dropdown - FOURTH */}
            <div className="flex flex-col">
              <label htmlFor="filter-method" className="text-sm mb-1">
                Filter By
              </label>
              <div className="flex items-center gap-2">
                <select
                  id="filter-method"
                  name="filter-method"
                  className="w-[200px] px-3 py-2 border border-gray-400 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600"
                  value={filterMethod}
                  onChange={(e) => setFilterMethod(e.target.value)}
                >
                  <option value="">Filter By</option>
                  <option value="CategoryId">Category</option>
                  <option value="ProfitCenterID">Profit Center</option>
                  <option value="GroupId">Group</option>
                  <option value="DesignationId">Designation</option>
                  <option value="DepartmentID">Department</option>
                </select>
              </div>
            </div>

            {/* Dynamic Options Dropdown - FIFTH */}
            <div className="flex flex-col">
              <label htmlFor="dynamic-options" className="text-sm mb-1">
                Choose Option
              </label>
              <select
                id="dynamic-options"
                name="dynamic-options"
                className="w-[200px] px-3 py-2 border border-gray-400 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600"
                onChange={(e) => {
                  const selectedOption = dropdownOptions?.find(
                    (option) => option.Name?.toString() === e.target.value,
                  );
                  if (selectedOption) {
                    handleFilterChange(
                      filterMethod,
                      selectedOption.Name,
                      selectedOption.Name,
                    );
                  }
                }}
              >
                <option value="" selected>
                  Choose One
                </option>
                {dropdownOptions?.length > 0 &&
                  dropdownOptions?.map((option) => (
                    <option key={option.Id} value={option.Name}>
                      {option.Name}
                    </option>
                  ))}
              </select>
            </div>
            <button onClick={handleClearFilter} className="btn btn-danger mt-4">
              Clear
            </button>
            {!showMonthly ? (
              <button
                className="btn btn-success mt-2"
                onClick={handleMonthlyClick}
              >
                Download PayBill
              </button>
            ) : (
              <button
                className="btn btn-success mt-2"
                onClick={handleMonthlyClickback}
              >
                Hide
              </button>
            )}

            {/* Search Input - LAST */}
            <div className="flex flex-col">
              <label htmlFor="employee-search" className="text-sm mb-1">
                Search Employees
              </label>
              <input
                type="search"
                id="employee-search"
                className="border rounded p-2 w-[300px]"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search by name /code/Category..."
              />
            </div>
            {showMonthly && (
              <>
                <div className="flex flex-col">
                  <label htmlFor="employee-search" className="text-sm mb-1">
                    From month
                  </label>
                  <input
                    type="month"
                    id="employee-search"
                    className="border rounded p-2 w-[300px]"
                    value={fromMonth}
                    onChange={(e) => setFromMonth(e.target.value)}
                    placeholder="Search by name or code..."
                  />
                </div>
                <div className="flex flex-col">
                  <label htmlFor="employee-search" className="text-sm mb-1">
                    To month
                  </label>
                  <input
                    type="month"
                    id="toMonth"
                    className="border rounded p-2 w-[300px]"
                    value={toMonth}
                    onChange={(e) => setToMonth(e.target.value)}
                    placeholder="Search by name or code..."
                  />
                </div>

                <div>
                  <button
                    onClick={handleFetchEmployeeMonthlyDetailed}
                    className="btn btn-danger mt-3"
                  >
                    Fetch Employee Paybill{" "}
                  </button>
                </div>
              </>
            )}
            <div>
              {selectedOption == "Weekly" ? (
                <button
                  type="button"
                  value=""
                  className="btn btn-primary"
                  onClick={() => {
                    // Filter employees without vouchers and pass only those
                    const employeesWithoutVoucher = filterdPayrollData.filter(
                      (emp) => !emp.VoucherNo,
                    );
                    if (employeesWithoutVoucher.length === 0) {
                      alert("All employees already have vouchers.");
                      return;
                    }
                    generateMultipleVouchers(employeesWithoutVoucher);
                  }}
                  disabled={filterdPayrollData.every((emp) => emp.VoucherNo)}
                >
                  voucher Payslip
                </button>
              ) : (
                <button
                  type="button"
                  value=""
                  className="btn btn-primary mt-4"
                  onClick={GenerateAllPayslips}
                >
                  Generate All Pay slip
                </button>
              )}
            </div>
          </div>
        </div>

        <>
          <div className="flex items-center flex-wrap gap-2 mb-3">
            <button
              className="btn btn-success"
              onClick={() => ConsoldatedPdf(filterdPayrollData, fromDate)}
            >
              Download Monthly Consolidation
            </button>
            <button
              className="btn btn-danger"
              onClick={() => SalaryStatement(filterdPayrollData, fromDate)}
            >
              Download Salary Statement
            </button>
            <button
              className="btn btn-primary"
              onClick={() =>
                generatePayrollReportpdf(
                  selectedColumnsData,
                  filterMethod,
                  filterdoption,
                  companyDetails,
                  UserName,
                  filterdPayrollData,
                )
              }
            >
              Download Detailed Payroll
            </button>
            <button
              className="btn btn-danger"
              onClick={() =>
                generatePayrollReportDeppdf(
                  selectedColumnsData,
                  filterMethod,
                  filterdoption,
                  companyDetails,
                  UserName,
                  filterdPayrollData,
                )
              }
            >
              Download Detailed Payroll Department wise
            </button>
            <button
              className="btn btn-success"
              onClick={() =>
                generatePayrollReportProfitCenterpdf(
                  selectedColumnsData,
                  filterMethod,
                  filterdoption,
                  companyDetails,
                  UserName,
                  filterdPayrollData,
                )
              }
            >
              Download Detailed Payroll Profitcenter wise
            </button>
            <button
              className="btn btn-primary"
              onClick={() => PfStatement(filterdPayrollData, pfData, fromDate)}
            >
              Download PF Statement
            </button>
            <button
              className="btn btn-primary"
              onClick={() =>
                EsiStatement(filterdPayrollData, Esidata, fromDate)
              }
            >
              Download ESI Statement
            </button>
            <div className="flex items-center">
              <select
                id="filter-dropdown"
                onChange={handleFilterPercentageChange}
                value={selectedFilter}
                className="rounded-md w-[200px] border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              >
                <option value="" selected>
                  Filter items based on %
                </option>
                <option value="above100">Above 100%</option>
                <option value="below50">Below 50%</option>
                <option value="below25">Below 25%</option>
              </select>
            </div>
            <div className="d-flex align-items-center gap-3 mb-2">
              <button
                className="btn btn-outline-danger d-flex align-items-center gap-2"
                onClick={handleFilterReport}
                title="Filter Columns"
              >
                <i className="bi bi-funnel-fill"></i>
                <span className="d-none d-md-inline">Filter Columns</span>
              </button>

              <span className="fw-bold text-lg text-danger">
                {selectedPayrollColumns.length} columns selected
              </span>
            </div>

            {selectedFilter && (
              <div className="flex items-center gap-4 mt-4">
                <button onClick={clearFilter} className="btn btn-danger">
                  Clear
                </button>

                <button
                  onClick={() =>
                    downloadFilteredDataPDF(filteredData, selectedFilter)
                  }
                  className="btn btn-primary"
                >
                  Download % wise Report
                </button>
              </div>
            )}
          </div>
        </>

        <div>
          <table className="table-auto w-full border-collapse border border-gray-200">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 px-4 py-2">
                  {" "}
                  {/* <input
                    type="checkbox"
                    className=""
                    checked={selectAll}
                    onChange={handleSelectAll}
                  />{" "} */}
                  Sl No
                </th>
                <th className="border border-gray-300 px-4 py-2">
                  Employee Name
                </th>
                <th className="border border-gray-300 px-4 py-2">
                  Total Working Days
                </th>
                <th className="border border-gray-300 px-4 py-2">
                  Employee Working Days
                </th>
                <th className="border border-gray-300 px-4 py-2">
                  Working Hours
                </th>
                <th className="border border-gray-300 px-4 py-2">
                  Total Leave
                </th>
                {/* <th className="border border-gray-300 px-4 py-2">
                  Wage Per Day
                </th> */}
                {/* <th className="border border-gray-300 px-4 py-2">Total Wage</th> */}
                <th className="border border-gray-300 px-4 py-2">Additions</th>
                <th className="border border-gray-300 px-4 py-2">Deductions</th>
                <th className="border border-gray-300 px-4 py-2">Net Total</th>

                <th className="border border-gray-300 px-4 py-2">Action</th>
              </tr>
            </thead>
            <tbody>
              {filterdPayrollData.length > 0 ? (
                filterdPayrollData?.map((employee, index) => {
                  const TotalCalculatedAddition = additionsDeductions
                    .filter(
                      (l) =>
                        l.EmpId === employee?.EmpId &&
                        (l.ComponentType === "Addition type" ||
                          l.ComponentType === "Addition"),
                    )
                    .reduce((total, AD) => {
                      const amount =
                        AD.ValueType === "Percentage"
                          ? (Number(AD.BaseAmount) *
                              Number(AD.PercentageValue || 0)) /
                            100
                          : Number(AD.CalculatedAmount || 0);
                      //("data amount", amount, "AD", AD);

                      // Ensure valid number is added
                      return total + (isNaN(amount) ? 0 : amount);
                    }, 0)
                    .toFixed(2);

                  const TotalCalculatedDeduction = additionsDeductions
                    .filter(
                      (l) =>
                        l.EmpId === employee?.EmpId &&
                        (l.ComponentType === "Deduction type" ||
                          l.ComponentType === "Deduction"),
                    )
                    .reduce((total, AD) => {
                      // Safely calculate deduction amount
                      const amount =
                        AD.ValueType === "Percentage"
                          ? (Number(AD.BaseAmount) *
                              Number(AD.PercentageValue)) /
                            100
                          : Number(AD.CalculatedAmount || 0);

                      // Ensure we're adding a number
                      return total + (isNaN(amount) ? 0 : amount);
                    }, 0)
                    ?.toFixed(2);
                  return (
                    <tr key={index}>
                      <td className="border border-gray-300 px-4 py-2">
                        {index + 1}
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        {employee.Name}-( {employee.Code})
                      </td>

                      <td className="border border-gray-300 px-4 py-2">
                        {" "}
                        {employee.TotalWorkingDays}
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        {" "}
                        {employee.EmployeeTotalWorkingDays}
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        {" "}
                        {employee.EmployeeTotalWorkingDays * 8}
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        {(parseFloat(employee?.TotalLeaveDays) || 0) +
                          (parseFloat(
                            employee?.TotalHalfDay_NOT_HalfDaysLOP_COUNT,
                          ) || 0)}
                      </td>

                      {/* <td className="border border-gray-300 px-4 py-2">
                        {employee.CurrentBasicPay || 0}
                      </td> */}
                      {/* <td className="border border-gray-300 px-4 py-2">
                        {employee?.CurrentBasicPay * employee?.TotalWorkingDays}
                      </td> */}
                      <td className="border border-gray-300 px-4 py-2">
                        <button
                          onClick={() => {
                            toggleAdditionsModal(employee.EmpId);
                          }}
                          className="btn btn-success ml-2"
                        >
                          {Math.round(employee?.TotalAdditions)?.toFixed(2) ??
                            0}
                        </button>
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        <button
                          onClick={() => {
                            toggleDeductionsModal(employee.EmpId);
                          }}
                          className="btn btn-danger ml-2"
                        >
                          {Math.round(employee?.TotalDeductions ?? 0).toFixed(
                            2,
                          )}
                        </button>
                        {/* <button
                          onClick={() => {
                            GeneratePayslip(employee.EmpId);
                          }}
                          className="btn btn-success mt-3 flex-end"
                        >
                          Generate Payslip
                        </button> */}
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        {" "}
                        <p>{Math.round(employee.NetSalary)?.toFixed(2)}</p>
                      </td>
                      {(selectedOption === "Monthly" ||
                        selectedOption === "Daily") && (
                        <td className="border border-gray-300 px-4 py-2">
                          {" "}
                          <button
                            onClick={() => {
                              GeneratePayslip(employee.EmpId);
                            }}
                            className="btn btn-success mt-3 flex-end"
                          >
                            Generate Payslip
                          </button>
                          {console.log(DetailedMonthlyPayroll, "dsadsasd")}
                          {DetailedMonthlyPayroll.length > 0 && (
                            <button
                              onClick={() =>
                                generateMonthlyConsoldatedEmployee(
                                  employee.EmpId,
                                  DetailedMonthlyPayroll,
                                  DetailedAddDedd,
                                  filterMethod,
                                  filterdoption,
                                )
                              }
                              className="btn btn-danger ms-1 justify-content-end"
                            >
                              PayBill
                            </button>
                          )}
                        </td>
                      )}

                      {selectedOption === "Weekly" && (
                        <td className="border border-gray-300 px-4 py-2">
                          <div className="flex gap-2">
                            <button
                              onClick={() => {
                                generateEmployeeVoucher(employee.EmpId);
                              }}
                              className="btn btn-primary mt-3"
                              disabled={employee.VoucherNo}
                            >
                              Generate Voucher
                            </button>
                          </div>
                        </td>
                      )}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td
                    colSpan="10"
                    className="border border-gray-300 px-4 py-2 text-center"
                  >
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {/* <button
            onClick={handleApprovePayrole}
            className="btn btn-success mt-3 flex-end "
          >
            Approve Payrole
          </button> */}
        </div>
      </div>
    </>
  );
}
export default PayRollReport;
